"use strict";

function _interopDefault(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var _Object$defineProperty = _interopDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property")),
    _Object$defineProperties = _interopDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties")),
    _Object$getOwnPropertyDescriptors = _interopDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors")),
    _Object$getOwnPropertyDescriptor = _interopDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor")),
    _Object$getOwnPropertySymbols = _interopDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols")),
    _Object$keys = _interopDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys")),
    _Reflect$construct = _interopDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct")),
    _extends = _interopDefault(require("@babel/runtime-corejs3/helpers/extends")),
    _everyInstanceProperty = _interopDefault(require("@babel/runtime-corejs3/core-js-stable/instance/every")),
    _someInstanceProperty = _interopDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some")),
    _bindInstanceProperty = _interopDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind")),
    _Object$assign = _interopDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign")),
    _filterInstanceProperty = _interopDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter")),
    _toConsumableArray = _interopDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray")),
    _findIndexInstanceProperty = _interopDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find-index")),
    _concatInstanceProperty = _interopDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat")),
    _objectWithoutProperties = _interopDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties")),
    _sortInstanceProperty = _interopDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort")),
    _spliceInstanceProperty = _interopDefault(require("@babel/runtime-corejs3/core-js-stable/instance/splice")),
    _reduceInstanceProperty = _interopDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce")),
    _Array$isArray = _interopDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array")),
    _typeof = _interopDefault(require("@babel/runtime-corejs3/helpers/typeof")),
    _forEachInstanceProperty = _interopDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each")),
    _Object$values = _interopDefault(require("@babel/runtime-corejs3/core-js-stable/object/values")),
    _mapInstanceProperty = _interopDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map")),
    _indexOfInstanceProperty = _interopDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of")),
    _classCallCheck = _interopDefault(require("@babel/runtime-corejs3/helpers/classCallCheck")),
    _createClass = _interopDefault(require("@babel/runtime-corejs3/helpers/createClass")),
    _assertThisInitialized = _interopDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized")),
    _inherits = _interopDefault(require("@babel/runtime-corejs3/helpers/inherits")),
    _possibleConstructorReturn = _interopDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn")),
    _getPrototypeOf = _interopDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf")),
    _defineProperty = _interopDefault(require("@babel/runtime-corejs3/helpers/defineProperty")),
    core = require("@material-ui/core"),
    styles = require("@material-ui/core/styles"),
    clsx = _interopDefault(require("clsx")),
    assignwith = _interopDefault(require("lodash.assignwith")),
    cloneDeep = _interopDefault(require("lodash.clonedeep")),
    find = _interopDefault(require("lodash.find")),
    isEqual = _interopDefault(require("lodash.isequal")),
    isUndefined = _interopDefault(require("lodash.isundefined")),
    merge = _interopDefault(require("lodash.merge")),
    PropTypes = _interopDefault(require("prop-types")),
    React = require("react"),
    React__default = _interopDefault(React),
    _startsWithInstanceProperty = _interopDefault(require("@babel/runtime-corejs3/core-js-stable/instance/starts-with")),
    Typography = _interopDefault(require("@material-ui/core/Typography")),
    MuiTableBody = _interopDefault(require("@material-ui/core/TableBody")),
    _sliceInstanceProperty = _interopDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice")),
    TableCell = _interopDefault(require("@material-ui/core/TableCell")),
    TableRow = _interopDefault(require("@material-ui/core/TableRow")),
    KeyboardArrowRightIcon = _interopDefault(require("@material-ui/icons/KeyboardArrowRight")),
    RemoveIcon = _interopDefault(require("@material-ui/icons/Remove")),
    _trimInstanceProperty = _interopDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim")),
    Button = _interopDefault(require("@material-ui/core/Button")),
    Checkbox = _interopDefault(require("@material-ui/core/Checkbox")),
    FormControl = _interopDefault(require("@material-ui/core/FormControl")),
    FormControlLabel = _interopDefault(require("@material-ui/core/FormControlLabel")),
    FormGroup = _interopDefault(require("@material-ui/core/FormGroup")),
    Input = _interopDefault(require("@material-ui/core/Input")),
    InputLabel = _interopDefault(require("@material-ui/core/InputLabel")),
    ListItemText = _interopDefault(require("@material-ui/core/ListItemText")),
    MenuItem = _interopDefault(require("@material-ui/core/MenuItem")),
    Select = _interopDefault(require("@material-ui/core/Select")),
    Chip = _interopDefault(require("@material-ui/core/Chip")),
    MuiTable = _interopDefault(require("@material-ui/core/Table")),
    MuiTableFooter = _interopDefault(require("@material-ui/core/TableFooter")),
    MuiTablePagination = _interopDefault(require("@material-ui/core/TablePagination")),
    _parseInt = _interopDefault(require("@babel/runtime-corejs3/core-js-stable/parse-int")),
    _slicedToArray = _interopDefault(require("@babel/runtime-corejs3/helpers/slicedToArray")),
    _setTimeout = _interopDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout")),
    HelpIcon = _interopDefault(require("@material-ui/icons/Help")),
    MuiTooltip = _interopDefault(require("@material-ui/core/Tooltip")),
    TableSortLabel = _interopDefault(require("@material-ui/core/TableSortLabel")),
    _Object$entries = _interopDefault(require("@babel/runtime-corejs3/core-js-stable/object/entries")),
    reactDnd = require("react-dnd"),
    Toolbar = _interopDefault(require("@material-ui/core/Toolbar")),
    IconButton = _interopDefault(require("@material-ui/core/IconButton")),
    MuiPopover = _interopDefault(require("@material-ui/core/Popover")),
    CloseIcon = _interopDefault(require("@material-ui/icons/Close")),
    Grow = _interopDefault(require("@material-ui/core/Grow")),
    TextField = _interopDefault(require("@material-ui/core/TextField")),
    SearchIcon = _interopDefault(require("@material-ui/icons/Search")),
    ClearIcon = _interopDefault(require("@material-ui/icons/Clear")),
    DownloadIcon = _interopDefault(require("@material-ui/icons/CloudDownload")),
    PrintIcon = _interopDefault(require("@material-ui/icons/Print")),
    ViewColumnIcon = _interopDefault(require("@material-ui/icons/ViewColumn")),
    FilterIcon = _interopDefault(require("@material-ui/icons/FilterList")),
    ReactToPrint = require("react-to-print"),
    ReactToPrint__default = _interopDefault(ReactToPrint),
    Paper = _interopDefault(require("@material-ui/core/Paper")),
    DeleteIcon = _interopDefault(require("@material-ui/icons/Delete")),
    reactDndHtml5Backend = require("react-dnd-html5-backend"),
    useStyles = styles.makeStyles(function (e) {
  return {
    root: {},
    cellHide: {
      display: "none"
    },
    simpleHeader: _defineProperty({}, e.breakpoints.down("xs"), {
      display: "inline-block",
      fontWeight: "bold",
      width: "100%",
      boxSizing: "border-box"
    }),
    simpleCell: _defineProperty({}, e.breakpoints.down("xs"), {
      display: "inline-block",
      width: "100%",
      boxSizing: "border-box"
    }),
    stackedHeader: {
      verticalAlign: "top"
    },
    stackedCommon: _defineProperty({}, e.breakpoints.down("sm"), {
      display: "inline-block",
      fontSize: "16px",
      height: "auto",
      width: "calc(50%)",
      boxSizing: "border-box",
      "&:last-child": {
        borderBottom: "none"
      },
      "&:nth-last-child(2)": {
        borderBottom: "none"
      }
    }),
    stackedCommonAlways: {
      display: "inline-block",
      fontSize: "16px",
      height: "auto",
      width: "calc(50%)",
      boxSizing: "border-box",
      "&:last-child": {
        borderBottom: "none"
      },
      "&:nth-last-child(2)": {
        borderBottom: "none"
      }
    },
    stackedParent: _defineProperty({}, e.breakpoints.down("sm"), {
      display: "inline-block",
      fontSize: "16px",
      height: "auto",
      width: "calc(100%)",
      boxSizing: "border-box"
    }),
    stackedParentAlways: {
      display: "inline-block",
      fontSize: "16px",
      height: "auto",
      width: "calc(100%)",
      boxSizing: "border-box"
    },
    cellStackedSmall: _defineProperty({}, e.breakpoints.down("sm"), {
      width: "50%",
      boxSizing: "border-box"
    }),
    responsiveStackedSmall: _defineProperty({}, e.breakpoints.down("sm"), {
      width: "50%",
      boxSizing: "border-box"
    }),
    responsiveStackedSmallParent: _defineProperty({}, e.breakpoints.down("sm"), {
      width: "100%",
      boxSizing: "border-box"
    })
  };
}, {
  name: "MUIDataTableBodyCell"
});

function TableBodyCell(e) {
  var t,
      o,
      a,
      r,
      n = useStyles(),
      s = e.children,
      l = e.colIndex,
      i = e.columnHeader,
      c = e.options,
      p = e.dataIndex,
      d = e.rowIndex,
      u = e.className,
      f = e.print,
      y = e.tableId,
      b = _objectWithoutProperties(e, ["children", "colIndex", "columnHeader", "options", "dataIndex", "rowIndex", "className", "print", "tableId"]),
      h = c.onCellClick,
      m = React.useCallback(function (e) {
    h(s, {
      colIndex: l,
      rowIndex: d,
      dataIndex: p,
      event: e
    });
  }, [h, s, l, d, p]),
      _ = {};

  h && (_.onClick = m);
  var g = [React__default.createElement("div", {
    key: 1,
    className: clsx((_defineProperty(t = {
      lastColumn: 2 === l
    }, n.root, !0), _defineProperty(t, n.cellHide, !0), _defineProperty(t, n.stackedHeader, !0), _defineProperty(t, n.stackedCommon, "vertical" === c.responsive || "stacked" === c.responsive || "stackedFullWidth" === c.responsive), _defineProperty(t, n.stackedCommonAlways, "verticalAlways" === c.responsive), _defineProperty(t, n.cellStackedSmall, "stacked" === c.responsive || "stackedFullWidth" === c.responsive && ("none" === c.setTableProps().padding || "small" === c.setTableProps().size)), _defineProperty(t, n.simpleHeader, "simple" === c.responsive), _defineProperty(t, "datatables-noprint", !f), t), u)
  }, i), React__default.createElement("div", {
    key: 2,
    className: clsx((_defineProperty(o = {}, n.root, !0), _defineProperty(o, n.stackedCommon, "vertical" === c.responsive || "stacked" === c.responsive || "stackedFullWidth" === c.responsive), _defineProperty(o, n.stackedCommonAlways, "verticalAlways" === c.responsive), _defineProperty(o, n.responsiveStackedSmall, "stacked" === c.responsive || "stackedFullWidth" === c.responsive && ("none" === c.setTableProps().padding || "small" === c.setTableProps().size)), _defineProperty(o, n.simpleCell, "simple" === c.responsive), _defineProperty(o, "datatables-noprint", !f), o), u)
  }, "function" == typeof s ? s(p, d) : s)],
      P = -1 !== _indexOfInstanceProperty(a = ["standard", "scrollMaxHeight", "scrollFullHeight", "scrollFullHeightFullWidth"]).call(a, c.responsive) ? _sliceInstanceProperty(g).call(g, 1, 2) : g;
  return React__default.createElement(TableCell, _extends({}, _, {
    "data-colindex": l,
    "data-tableid": y,
    className: clsx((_defineProperty(r = {}, n.root, !0), _defineProperty(r, n.stackedParent, "vertical" === c.responsive || "stacked" === c.responsive || "stackedFullWidth" === c.responsive), _defineProperty(r, n.stackedParentAlways, "verticalAlways" === c.responsive), _defineProperty(r, n.responsiveStackedSmallParent, "vertical" === c.responsive || "stacked" === c.responsive || "stackedFullWidth" === c.responsive && ("none" === c.setTableProps().padding || "small" === c.setTableProps().size)), _defineProperty(r, n.simpleCell, "simple" === c.responsive), _defineProperty(r, "datatables-noprint", !f), r), u)
  }, b), P);
}

function _createSuper(a) {
  var r = _isNativeReflectConstruct();

  return function () {
    var e,
        t,
        o = _getPrototypeOf(a);

    return t = r ? (e = _getPrototypeOf(this).constructor, _Reflect$construct(o, arguments, e)) : o.apply(this, arguments), _possibleConstructorReturn(this, t);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !_Reflect$construct) return !1;
  if (_Reflect$construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

var defaultBodyRowStyles = function defaultBodyRowStyles(e) {
  return {
    root: {
      "&.Mui-selected": {
        backgroundColor: e.palette.action.selected
      },
      "&.mui-row-selected": {
        backgroundColor: e.palette.action.selected
      }
    },
    hoverCursor: {
      cursor: "pointer"
    },
    responsiveStacked: _defineProperty({}, e.breakpoints.down("sm"), {
      borderTop: "solid 2px rgba(0, 0, 0, 0.15)",
      borderBottom: "solid 2px rgba(0, 0, 0, 0.15)",
      padding: 0,
      margin: 0
    }),
    responsiveSimple: _defineProperty({}, e.breakpoints.down("xs"), {
      borderTop: "solid 2px rgba(0, 0, 0, 0.15)",
      borderBottom: "solid 2px rgba(0, 0, 0, 0.15)",
      padding: 0,
      margin: 0
    })
  };
},
    TableBodyRow = function (e) {
  _inherits(o, e);

  var t = _createSuper(o);

  function o() {
    return _classCallCheck(this, o), t.apply(this, arguments);
  }

  return _createClass(o, [{
    key: "render",
    value: function value() {
      var e,
          t = this.props,
          o = t.classes,
          a = t.options,
          r = t.rowSelected,
          n = t.onClick,
          s = t.className,
          l = t.isRowSelectable,
          i = _objectWithoutProperties(t, ["classes", "options", "rowSelected", "onClick", "className", "isRowSelectable"]),
          c = {};

      return n && (c.onClick = n), React__default.createElement(TableRow, _extends({
        hover: !!a.rowHover
      }, c, {
        className: clsx((_defineProperty(e = {}, o.root, !0), _defineProperty(e, o.hover, a.rowHover), _defineProperty(e, o.hoverCursor, a.selectableRowsOnClick && l || a.expandableRowsOnClick), _defineProperty(e, o.responsiveSimple, "simple" === a.responsive), _defineProperty(e, o.responsiveStacked, "vertical" === a.responsive || "stacked" === a.responsive || "stackedFullWidth" === a.responsive), _defineProperty(e, "mui-row-selected", r), e), s),
        selected: r
      }, i), this.props.children);
    }
  }]), o;
}(React__default.Component);

_defineProperty(TableBodyRow, "propTypes", {
  options: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  rowSelected: PropTypes.bool,
  classes: PropTypes.object
});

var TableBodyRow$1 = styles.withStyles(defaultBodyRowStyles, {
  name: "MUIDataTableBodyRow"
})(TableBodyRow),
    ExpandButton = function ExpandButton(e) {
  var t = e.areAllRowsExpanded,
      o = e.buttonClass,
      a = e.expandableRowsHeader,
      r = e.expandedRows,
      n = e.iconClass,
      s = e.iconIndeterminateClass,
      l = e.isHeaderCell,
      i = e.onExpand;
  return React__default.createElement(React__default.Fragment, null, l && !t() && t && 0 < r.data.length ? React__default.createElement(core.IconButton, {
    onClick: i,
    style: {
      padding: 0
    },
    disabled: !1 === a,
    className: o
  }, React__default.createElement(RemoveIcon, {
    id: "expandable-button",
    className: s
  })) : React__default.createElement(core.IconButton, {
    onClick: i,
    style: {
      padding: 0
    },
    disabled: !1 === a,
    className: o
  }, React__default.createElement(KeyboardArrowRightIcon, {
    id: "expandable-button",
    className: n
  })));
},
    useStyles$1 = styles.makeStyles(function (e) {
  return {
    root: {
      "@media print": {
        display: "none"
      }
    },
    fixedHeader: {
      position: "sticky",
      top: "0px",
      zIndex: 100
    },
    fixedLeft: {
      position: "sticky",
      left: "0px",
      zIndex: 100
    },
    icon: {
      cursor: "pointer",
      transition: "transform 0.25s"
    },
    expanded: {
      transform: "rotate(90deg)"
    },
    hide: {
      visibility: "hidden"
    },
    headerCell: {
      zIndex: 110,
      backgroundColor: e.palette.background.paper
    },
    expandDisabled: {},
    checkboxRoot: {},
    checked: {},
    disabled: {}
  };
}, {
  name: "MUIDataTableSelectCell"
}),
    TableSelectCell = function TableSelectCell(e) {
  var t,
      o,
      a,
      r = e.fixedHeader,
      n = e.fixedSelectColumn,
      s = e.isHeaderCell,
      l = void 0 !== s && s,
      i = e.expandableOn,
      c = void 0 !== i && i,
      p = e.selectableOn,
      d = void 0 === p ? "none" : p,
      u = e.isRowExpanded,
      f = void 0 !== u && u,
      y = e.onExpand,
      b = e.isRowSelectable,
      h = e.selectableRowsHeader,
      m = e.hideExpandButton,
      _ = e.expandableRowsHeader,
      g = e.expandedRows,
      P = e.areAllRowsExpanded,
      T = void 0 === P ? function () {
    return !1;
  } : P,
      R = e.selectableRowsHideCheckboxes,
      x = e.setHeadCellRef,
      v = e.dataIndex,
      w = e.components,
      I = void 0 === w ? {} : w,
      C = _objectWithoutProperties(e, ["fixedHeader", "fixedSelectColumn", "isHeaderCell", "expandableOn", "selectableOn", "isRowExpanded", "onExpand", "isRowSelectable", "selectableRowsHeader", "hideExpandButton", "expandableRowsHeader", "expandedRows", "areAllRowsExpanded", "selectableRowsHideCheckboxes", "setHeadCellRef", "dataIndex", "components"]),
      S = useStyles$1(),
      D = I.Checkbox || core.Checkbox,
      O = I.ExpandButton || ExpandButton;

  if (!1 === c && ("none" === d || !0 === R)) return null;
  var k = clsx((_defineProperty(t = {}, S.root, !0), _defineProperty(t, S.fixedHeader, r && l), _defineProperty(t, S.fixedLeft, n), _defineProperty(t, S.headerCell, l), t)),
      E = clsx(_defineProperty({}, S.expandDisabled, m)),
      L = clsx((_defineProperty(o = {}, S.icon, !0), _defineProperty(o, S.hide, l && !_), _defineProperty(o, S.expanded, f || l && T()), o)),
      F = clsx((_defineProperty(a = {}, S.icon, !0), _defineProperty(a, S.hide, l && !_), a)),
      j = {};
  x && (j.ref = function (e) {
    x(0, 0, e);
  });
  return React__default.createElement(core.TableCell, _extends({
    className: k,
    padding: "checkbox"
  }, j), React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, c && React__default.createElement(O, {
    isHeaderCell: l,
    areAllRowsExpanded: T,
    expandedRows: g,
    onExpand: y,
    expandableRowsHeader: _,
    buttonClass: E,
    iconIndeterminateClass: F,
    iconClass: L,
    dataIndex: v
  }), "none" !== d && !0 !== R && (!l || "multiple" === d && !1 !== h ? React__default.createElement(D, _extends({
    classes: {
      root: S.checkboxRoot,
      checked: S.checked,
      disabled: S.disabled
    },
    "data-description": l ? "row-select-header" : "row-select",
    "data-index": v || null,
    color: "primary",
    disabled: !b
  }, C)) : null)));
};

function buildMap(e) {
  return _reduceInstanceProperty(e).call(e, function (e, t) {
    return e[t.dataIndex] = !0, e;
  }, {});
}

function escapeDangerousCSVCharacters(e) {
  return "string" == typeof e ? e.replace(/^\+|^\-|^\=|^\@/g, "'$&") : e;
}

function warnDeprecated(e) {
  var t = !(1 < arguments.length && void 0 !== arguments[1]) || arguments[1],
      o = "function" == typeof t ? t : console.warn;
  t && o("Deprecation Notice:  ".concat(e));
}

function warnInfo(e) {
  var t = !(1 < arguments.length && void 0 !== arguments[1]) || arguments[1],
      o = "function" == typeof t ? t : console.warn;
  t && o("".concat(e));
}

function getPageValue(e, t, o) {
  var a = e <= t ? 1 : Math.ceil(e / t);
  return a <= o ? a - 1 : o;
}

function getCollatorComparator() {
  if (Intl) return new Intl.Collator(void 0, {
    numeric: !0,
    sensitivity: "base"
  }).compare;
  return function (e, t) {
    return e.localeCompare(t);
  };
}

function sortCompare(r) {
  return function (e, t) {
    var o = null === e.data || void 0 === e.data ? "" : e.data,
        a = null === t.data || void 0 === t.data ? "" : t.data;
    return ("function" == typeof o.localeCompare ? o.localeCompare(a) : o - a) * ("asc" === r ? 1 : -1);
  };
}

function buildCSV(r, e, n) {
  function s(e) {
    return "string" == typeof e ? e.replace(/\"/g, '""') : e;
  }

  function t(e) {
    var t;
    return _sliceInstanceProperty(t = _reduceInstanceProperty(e).call(e, function (e, t) {
      return t.download ? e + '"' + escapeDangerousCSVCharacters(s(t.label || t.name)) + '"' + n.downloadOptions.separator : e;
    }, "")).call(t, 0, -1) + "\r\n";
  }

  function o(e) {
    var t;
    return e.length ? _trimInstanceProperty(t = _reduceInstanceProperty(e).call(e, function (e, t) {
      var o, a;
      return e + '"' + _mapInstanceProperty(o = _filterInstanceProperty(a = t.data).call(a, function (e, t) {
        return r[t].download;
      })).call(o, function (e) {
        return escapeDangerousCSVCharacters(s(e));
      }).join('"' + n.downloadOptions.separator + '"') + '"\r\n';
    }, "")).call(t) : "";
  }

  var a,
      l,
      i = t(r),
      c = o(e);
  return n.onDownload ? n.onDownload(t, o, r, e) : _trimInstanceProperty(a = _concatInstanceProperty(l = "".concat(i)).call(l, c)).call(a);
}

function downloadCSV(e, t) {
  var o,
      a,
      r,
      n,
      s = new Blob([e], {
    type: "text/csv"
  });
  navigator && navigator.msSaveOrOpenBlob ? navigator.msSaveOrOpenBlob(s, t) : (o = "data:text/csv;charset=utf-8,".concat(e), r = void 0 === (a = window.URL || window.webkitURL).createObjectURL ? o : a.createObjectURL(s), (n = document.createElement("a")).setAttribute("href", r), n.setAttribute("download", t), document.body.appendChild(n), n.click(), document.body.removeChild(n));
}

function createCSVDownload(e, t, o, a) {
  var r = buildCSV(e, t, o);
  o.onDownload && !1 === r || a(r, o.downloadOptions.filename);
}

function _createSuper$1(a) {
  var r = _isNativeReflectConstruct$1();

  return function () {
    var e,
        t,
        o = _getPrototypeOf(a);

    return t = r ? (e = _getPrototypeOf(this).constructor, _Reflect$construct(o, arguments, e)) : o.apply(this, arguments), _possibleConstructorReturn(this, t);
  };
}

function _isNativeReflectConstruct$1() {
  if ("undefined" == typeof Reflect || !_Reflect$construct) return !1;
  if (_Reflect$construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

TableSelectCell.propTypes = {
  checked: PropTypes.bool.isRequired,
  fixedHeader: PropTypes.bool,
  onChange: PropTypes.func,
  classes: PropTypes.object,
  expandableOn: PropTypes.bool,
  hideExpandButton: PropTypes.bool,
  selectableOn: PropTypes.string,
  isRowSelectable: PropTypes.bool
};

var defaultBodyStyles = function defaultBodyStyles(e) {
  return {
    root: {},
    emptyTitle: {
      textAlign: "center"
    },
    lastStackedCell: _defineProperty({}, e.breakpoints.down("sm"), {
      "& td:last-child": {
        borderBottom: "none"
      }
    }),
    lastSimpleCell: _defineProperty({}, e.breakpoints.down("xs"), {
      "& td:last-child": {
        borderBottom: "none"
      }
    })
  };
},
    TableBody = function (e) {
  _inherits(n, e);

  var r = _createSuper$1(n);

  function n() {
    var e, c;

    _classCallCheck(this, n);

    for (var t = arguments.length, o = new Array(t), a = 0; a < t; a++) o[a] = arguments[a];

    return c = r.call.apply(r, _concatInstanceProperty(e = [this]).call(e, o)), _defineProperty(_assertThisInitialized(c), "handleRowSelect", function (a, e) {
      var t = !(!e || !e.nativeEvent) && e.nativeEvent.shiftKey,
          r = [],
          o = c.props.previousSelectedRow;

      if (t && o && o.index < c.props.data.length) {
        var n,
            s = o.index,
            l = cloneDeep(c.props.selectedRows),
            i = c.props.data[a.index].dataIndex;
        0 === _filterInstanceProperty(n = l.data).call(n, function (e) {
          return e.dataIndex === i;
        }).length && (l.data.push({
          index: a.index,
          dataIndex: i
        }), l.lookup[i] = !0);

        for (; s !== a.index;) !function () {
          var e,
              t,
              o = c.props.data[s].dataIndex;
          c.isRowSelectable(o, l) && (t = {
            index: s,
            dataIndex: o
          }, 0 === _filterInstanceProperty(e = l.data).call(e, function (e) {
            return e.dataIndex === o;
          }).length && (l.data.push(t), l.lookup[o] = !0), r.push(t)), s = a.index > s ? s + 1 : s - 1;
        }();
      }

      c.props.selectRowUpdate("cell", a, r);
    }), _defineProperty(_assertThisInitialized(c), "handleRowClick", function (e, t, o) {
      var a, r, n;
      "expandable-button" === o.target.id || "path" === o.target.nodeName && "expandable-button" === o.target.parentNode.id || o.target.id && _startsWithInstanceProperty(a = o.target.id).call(a, "MUIDataTableSelectCell") || (c.props.options.selectableRowsOnClick && "none" !== c.props.options.selectableRows && c.isRowSelectable(t.dataIndex, c.props.selectedRows) && (r = {
        index: t.rowIndex,
        dataIndex: t.dataIndex
      }, c.handleRowSelect(r, o)), c.props.options.expandableRowsOnClick && c.props.options.expandableRows && c.isRowExpandable(t.dataIndex, c.props.expandedRows) && (n = {
        index: t.rowIndex,
        dataIndex: t.dataIndex
      }, c.props.toggleExpandRow(n)), c.props.options.selectableRowsOnClick || c.props.options.onRowClick && c.props.options.onRowClick(e, t, o));
    }), _defineProperty(_assertThisInitialized(c), "processRow", function (e, t) {
      for (var o = [], a = 0; a < e.length; a++) o.push({
        value: e[t[a]],
        index: t[a]
      });

      return o;
    }), c;
  }

  return _createClass(n, [{
    key: "buildRows",
    value: function value() {
      var e = this.props,
          t = e.data,
          o = e.page,
          a = e.rowsPerPage,
          r = e.count;
      if (this.props.options.serverSide) return t.length ? t : null;
      var n = [],
          s = getPageValue(r, a, o),
          l = 0 === s ? 0 : s * a,
          i = Math.min(r, (s + 1) * a);
      s < o && console.warn("Current page is out of range, using the highest page that is in range instead.");

      for (var c = l; c < r && c < i; c++) void 0 !== t[c] && n.push(t[c]);

      return n.length ? n : null;
    }
  }, {
    key: "getRowIndex",
    value: function value(e) {
      var t = this.props,
          o = t.page,
          a = t.rowsPerPage;
      return t.options.serverSide ? e : (0 === o ? 0 : o * a) + e;
    }
  }, {
    key: "isRowSelected",
    value: function value(e) {
      var t = this.props.selectedRows;
      return !(!t.lookup || !t.lookup[e]);
    }
  }, {
    key: "isRowExpanded",
    value: function value(e) {
      var t = this.props.expandedRows;
      return !(!t.lookup || !t.lookup[e]);
    }
  }, {
    key: "isRowSelectable",
    value: function value(e, t) {
      var o = this.props.options;
      return t = t || this.props.selectedRows, !o.isRowSelectable || o.isRowSelectable(e, t);
    }
  }, {
    key: "isRowExpandable",
    value: function value(e) {
      var t = this.props,
          o = t.options,
          a = t.expandedRows;
      return !o.isRowExpandable || o.isRowExpandable(e, a);
    }
  }, {
    key: "render",
    value: function value() {
      var e,
          d = this,
          t = this.props,
          u = t.classes,
          f = t.columns,
          y = t.toggleExpandRow,
          b = t.options,
          o = t.columnOrder,
          h = void 0 === o ? _mapInstanceProperty(e = this.props.columns).call(e, function (e, t) {
        return t;
      }) : o,
          a = t.components,
          m = void 0 === a ? {} : a,
          _ = t.tableId,
          r = this.buildRows(),
          n = _filterInstanceProperty(f).call(f, function (e) {
        return "true" === e.display;
      }).length;

      return React__default.createElement(MuiTableBody, null, r && 0 < r.length ? _mapInstanceProperty(r).call(r, function (e, o) {
        var t,
            a,
            r,
            n = e.data,
            s = e.dataIndex;
        if (b.customRowRender) return b.customRowRender(n, s, o);
        var l = "none" !== b.selectableRows && d.isRowSelected(s),
            i = d.isRowSelectable(s),
            c = b.setRowProps && b.setRowProps(n, s, o) || {},
            p = d.processRow(n, h);
        return React__default.createElement(React__default.Fragment, {
          key: o
        }, React__default.createElement(TableBodyRow$1, _extends({}, c, {
          options: b,
          rowSelected: l,
          isRowSelectable: i,
          onClick: _bindInstanceProperty(t = d.handleRowClick).call(t, null, n, {
            rowIndex: o,
            dataIndex: s
          }),
          className: clsx((_defineProperty(a = {}, u.lastStackedCell, "vertical" === b.responsive || "stacked" === b.responsive || "stackedFullWidth" === b.responsive), _defineProperty(a, u.lastSimpleCell, "simple" === b.responsive), _defineProperty(a, c.className, c.className), a)),
          "data-testid": "MUIDataTableBodyRow-" + s,
          id: "MUIDataTableBodyRow-" + s
        }), React__default.createElement(TableSelectCell, {
          onChange: _bindInstanceProperty(r = d.handleRowSelect).call(r, null, {
            index: d.getRowIndex(o),
            dataIndex: s
          }),
          onExpand: _bindInstanceProperty(y).call(y, null, {
            index: d.getRowIndex(o),
            dataIndex: s
          }),
          fixedHeader: b.fixedHeader,
          fixedSelectColumn: b.fixedSelectColumn,
          checked: l,
          expandableOn: b.expandableRows,
          hideExpandButton: !d.isRowExpandable(s) && b.expandableRows,
          selectableOn: b.selectableRows,
          selectableRowsHideCheckboxes: b.selectableRowsHideCheckboxes,
          isRowExpanded: d.isRowExpanded(s),
          isRowSelectable: i,
          dataIndex: s,
          id: "MUIDataTableSelectCell-" + s,
          components: m
        }), _mapInstanceProperty(p).call(p, function (e) {
          var t;
          return "true" === f[e.index].display && React__default.createElement(TableBodyCell, _extends({}, f[e.index].setCellProps && f[e.index].setCellProps(e.value, s, e.index) || {}, {
            "data-testid": _concatInstanceProperty(t = "MuiDataTableBodyCell-".concat(e.index, "-")).call(t, o),
            dataIndex: s,
            rowIndex: o,
            colIndex: e.index,
            columnHeader: f[e.index].label,
            print: f[e.index].print,
            options: b,
            tableId: _,
            key: e.index
          }), e.value);
        })), d.isRowExpanded(s) && b.renderExpandableRow(n, {
          rowIndex: o,
          dataIndex: s
        }));
      }) : React__default.createElement(TableBodyRow$1, {
        options: b
      }, React__default.createElement(TableBodyCell, {
        colSpan: "none" !== b.selectableRows || b.expandableRows ? n + 1 : n,
        options: b,
        colIndex: 0,
        rowIndex: 0
      }, React__default.createElement(Typography, {
        variant: "body1",
        className: u.emptyTitle,
        component: "div"
      }, b.textLabels.body.noMatch))));
    }
  }]), n;
}(React__default.Component);

_defineProperty(TableBody, "propTypes", {
  data: PropTypes.array.isRequired,
  count: PropTypes.number.isRequired,
  columns: PropTypes.array.isRequired,
  options: PropTypes.object.isRequired,
  filterList: PropTypes.array,
  onRowClick: PropTypes.func,
  expandedRows: PropTypes.object,
  selectedRows: PropTypes.object,
  selectRowUpdate: PropTypes.func,
  previousSelectedRow: PropTypes.object,
  searchText: PropTypes.string,
  toggleExpandRow: PropTypes.func,
  classes: PropTypes.object
}), _defineProperty(TableBody, "defaultProps", {
  toggleExpandRow: function toggleExpandRow() {}
});
var DefaultTableBody = styles.withStyles(defaultBodyStyles, {
  name: "MUIDataTableBody"
})(TableBody);

function _createSuper$2(a) {
  var r = _isNativeReflectConstruct$2();

  return function () {
    var e,
        t,
        o = _getPrototypeOf(a);

    return t = r ? (e = _getPrototypeOf(this).constructor, _Reflect$construct(o, arguments, e)) : o.apply(this, arguments), _possibleConstructorReturn(this, t);
  };
}

function _isNativeReflectConstruct$2() {
  if ("undefined" == typeof Reflect || !_Reflect$construct) return !1;
  if (_Reflect$construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

var defaultFilterStyles = function defaultFilterStyles(e) {
  return {
    root: {
      backgroundColor: e.palette.background.default,
      padding: "24px 24px 36px 24px",
      fontFamily: "Roboto"
    },
    header: {
      flex: "0 0 auto",
      marginBottom: "16px",
      width: "100%",
      display: "flex",
      justifyContent: "space-between"
    },
    title: {
      display: "inline-block",
      marginLeft: "7px",
      color: e.palette.text.primary,
      fontSize: "14px",
      fontWeight: 500
    },
    noMargin: {
      marginLeft: "0px"
    },
    reset: {
      alignSelf: "left"
    },
    resetLink: {
      marginLeft: "16px",
      fontSize: "12px",
      cursor: "pointer"
    },
    filtersSelected: {
      alignSelf: "right"
    },
    checkboxListTitle: {
      marginLeft: "7px",
      marginBottom: "8px",
      fontSize: "14px",
      color: e.palette.text.secondary,
      textAlign: "left",
      fontWeight: 500
    },
    checkboxFormGroup: {
      marginTop: "8px"
    },
    checkboxFormControl: {
      margin: "0px"
    },
    checkboxFormControlLabel: {
      fontSize: "15px",
      marginLeft: "8px",
      color: e.palette.text.primary
    },
    checkboxIcon: {
      width: "32px",
      height: "32px"
    },
    checkbox: {},
    checked: {},
    gridListTile: {
      marginTop: "16px"
    }
  };
},
    TableFilter = function (e) {
  _inherits(o, e);

  var t = _createSuper$2(o);

  function o(e) {
    var l;
    return _classCallCheck(this, o), l = t.call(this, e), _defineProperty(_assertThisInitialized(l), "filterUpdate", function (e, t, o, a, r) {
      var n,
          s = _sliceInstanceProperty(n = l.state.filterList).call(n, 0);

      l.props.updateFilterByType(s, e, t, a, r), l.setState({
        filterList: s
      });
    }), _defineProperty(_assertThisInitialized(l), "handleCheckboxChange", function (e, t, o) {
      l.filterUpdate(e, t, o, "checkbox"), !0 !== l.props.options.confirmFilters && l.props.onFilterUpdate(e, t, o, "checkbox");
    }), _defineProperty(_assertThisInitialized(l), "handleDropdownChange", function (e, t, o) {
      var a = _filterInstanceProperty(l.props.options.textLabels).all,
          r = e.target.value === a ? [] : [e.target.value];

      l.filterUpdate(t, r, o, "dropdown"), !0 !== l.props.options.confirmFilters && l.props.onFilterUpdate(t, r, o, "dropdown");
    }), _defineProperty(_assertThisInitialized(l), "handleMultiselectChange", function (e, t, o) {
      l.filterUpdate(e, t, o, "multiselect"), !0 !== l.props.options.confirmFilters && l.props.onFilterUpdate(e, t, o, "multiselect");
    }), _defineProperty(_assertThisInitialized(l), "handleTextFieldChange", function (e, t, o) {
      l.filterUpdate(t, e.target.value, o, "textField"), !0 !== l.props.options.confirmFilters && l.props.onFilterUpdate(t, e.target.value, o, "textField");
    }), _defineProperty(_assertThisInitialized(l), "handleCustomChange", function (e, t, o) {
      l.filterUpdate(t, e, o.name, o.filterType), !0 !== l.props.options.confirmFilters && l.props.onFilterUpdate(t, e, o.name, o.filterType);
    }), _defineProperty(_assertThisInitialized(l), "applyFilters", function () {
      var e;
      return _forEachInstanceProperty(e = l.state.filterList).call(e, function (e, t) {
        l.props.onFilterUpdate(t, e, l.props.columns[t], "custom");
      }), l.props.handleClose(), l.props.options.onFilterConfirm && l.props.options.onFilterConfirm(l.state.filterList), l.state.filterList;
    }), _defineProperty(_assertThisInitialized(l), "resetFilters", function () {
      var e;
      l.setState({
        filterList: _mapInstanceProperty(e = l.props.columns).call(e, function () {
          return [];
        })
      }), !0 !== l.props.options.confirmFilters && l.props.onFilterReset();
    }), l.state = {
      filterList: cloneDeep(e.filterList)
    }, l;
  }

  return _createClass(o, [{
    key: "renderCheckbox",
    value: function value(r, n, e) {
      var t,
          s = this,
          l = (2 < arguments.length && void 0 !== e ? e : {}).Checkbox || Checkbox,
          o = this.props,
          i = o.classes,
          a = o.filterData,
          c = this.state.filterList,
          p = r.filterOptions && r.filterOptions.renderValue ? r.filterOptions.renderValue : function (e) {
        return e;
      };
      return React__default.createElement(core.Grid, {
        item: !0,
        key: n,
        xs: 6
      }, React__default.createElement(FormGroup, null, React__default.createElement(core.Grid, {
        item: !0,
        xs: 12
      }, React__default.createElement(Typography, {
        variant: "body2",
        className: i.checkboxListTitle
      }, r.label)), React__default.createElement(core.Grid, {
        container: !0
      }, _mapInstanceProperty(t = a[n]).call(t, function (e, t) {
        var o, a;
        return React__default.createElement(core.Grid, {
          item: !0,
          key: t
        }, React__default.createElement(FormControlLabel, {
          key: t,
          classes: {
            root: i.checkboxFormControl,
            label: i.checkboxFormControlLabel
          },
          control: React__default.createElement(l, {
            "data-description": "table-filter",
            color: "primary",
            className: i.checkboxIcon,
            onChange: _bindInstanceProperty(o = s.handleCheckboxChange).call(o, null, n, e, r.name),
            checked: 0 <= _indexOfInstanceProperty(a = c[n]).call(a, e),
            classes: {
              root: i.checkbox,
              checked: i.checked
            },
            value: null != e ? e.toString() : ""
          }),
          label: p(e)
        }));
      }))));
    }
  }, {
    key: "renderSelect",
    value: function value(t, o) {
      var e,
          a = this,
          r = this.props,
          n = r.classes,
          s = r.filterData,
          l = r.options,
          i = this.state.filterList,
          c = _filterInstanceProperty(l.textLabels),
          p = t.filterOptions && t.filterOptions.renderValue ? t.filterOptions.renderValue : function (e) {
        return null != e ? e.toString() : "";
      },
          d = !0 === (t.filterOptions && t.filterOptions.fullWidth) ? 12 : 6;

      return React__default.createElement(core.Grid, {
        item: !0,
        key: o,
        xs: d,
        classes: {
          "grid-xs-12": n.gridListTile,
          "grid-xs-6": n.gridListTile
        }
      }, React__default.createElement(FormControl, {
        key: o,
        fullWidth: !0
      }, React__default.createElement(InputLabel, {
        htmlFor: t.name
      }, t.label), React__default.createElement(Select, {
        fullWidth: !0,
        value: i[o].length ? i[o].toString() : c.all,
        name: t.name,
        onChange: function onChange(e) {
          return a.handleDropdownChange(e, o, t.name);
        },
        input: React__default.createElement(Input, {
          name: t.name,
          id: t.name
        })
      }, React__default.createElement(MenuItem, {
        value: c.all,
        key: 0
      }, c.all), _mapInstanceProperty(e = s[o]).call(e, function (e, t) {
        return React__default.createElement(MenuItem, {
          value: e,
          key: t + 1
        }, p(e));
      }))));
    }
  }, {
    key: "renderTextField",
    value: function value(t, o) {
      var a = this,
          e = this.props.classes,
          r = this.state.filterList;
      t.filterOptions && t.filterOptions.renderValue && console.warn("Custom renderValue not supported for textField filters");
      var n = !0 === (t.filterOptions && t.filterOptions.fullWidth) ? 12 : 6;
      return React__default.createElement(core.Grid, {
        item: !0,
        key: o,
        xs: n,
        classes: {
          "grid-xs-12": e.gridListTile,
          "grid-xs-6": e.gridListTile
        }
      }, React__default.createElement(FormControl, {
        key: o,
        fullWidth: !0
      }, React__default.createElement(core.TextField, {
        fullWidth: !0,
        label: t.label,
        value: r[o].toString() || "",
        "data-testid": "filtertextfield-" + t.name,
        onChange: function onChange(e) {
          return a.handleTextFieldChange(e, o, t.name);
        }
      })));
    }
  }, {
    key: "renderMultiselect",
    value: function value(t, a, e) {
      var o,
          r = this,
          n = (2 < arguments.length && void 0 !== e ? e : {}).Checkbox || Checkbox,
          s = this.props,
          l = s.classes,
          i = s.filterData,
          c = this.state.filterList,
          p = t.filterOptions && t.filterOptions.renderValue ? t.filterOptions.renderValue : function (e) {
        return e;
      },
          d = !0 === (t.filterOptions && t.filterOptions.fullWidth) ? 12 : 6;
      return React__default.createElement(core.Grid, {
        item: !0,
        key: a,
        xs: d,
        classes: {
          "grid-xs-12": l.gridListTile,
          "grid-xs-6": l.gridListTile
        }
      }, React__default.createElement(FormControl, {
        key: a,
        fullWidth: !0
      }, React__default.createElement(InputLabel, {
        htmlFor: t.name
      }, t.label), React__default.createElement(Select, {
        multiple: !0,
        fullWidth: !0,
        value: c[a] || [],
        renderValue: function renderValue(e) {
          return _mapInstanceProperty(e).call(e, p).join(", ");
        },
        name: t.name,
        onChange: function onChange(e) {
          return r.handleMultiselectChange(a, e.target.value, t.name);
        },
        input: React__default.createElement(Input, {
          name: t.name,
          id: t.name
        })
      }, _mapInstanceProperty(o = i[a]).call(o, function (e, t) {
        var o;
        return React__default.createElement(MenuItem, {
          value: e,
          key: t + 1
        }, React__default.createElement(n, {
          "data-description": "table-filter",
          color: "primary",
          checked: 0 <= _indexOfInstanceProperty(o = c[a]).call(o, e),
          value: null != e ? e.toString() : "",
          className: l.checkboxIcon,
          classes: {
            root: l.checkbox,
            checked: l.checked
          }
        }), React__default.createElement(ListItemText, {
          primary: p(e)
        }));
      }))));
    }
  }, {
    key: "renderCustomField",
    value: function value(e, t) {
      var o = this.props,
          a = o.classes,
          r = o.filterData,
          n = o.options,
          s = this.state.filterList,
          l = !0 === (e.filterOptions && e.filterOptions.fullWidth) ? 12 : 6,
          i = e.filterOptions && e.filterOptions.display || n.filterOptions && n.filterOptions.display;
      if (i) return e.filterListOptions && e.filterListOptions.renderValue && console.warning('"renderValue" is ignored for custom filter fields'), React__default.createElement(core.Grid, {
        item: !0,
        key: t,
        xs: l,
        classes: {
          "grid-xs-12": a.gridListTile,
          "grid-xs-6": a.gridListTile
        }
      }, React__default.createElement(FormControl, {
        key: t,
        fullWidth: !0
      }, i(s, this.handleCustomChange, t, e, r)));
      console.error('Property "display" is required when using custom filter type.');
    }
  }, {
    key: "render",
    value: function value() {
      var a = this,
          e = this.props,
          t = e.classes,
          o = e.columns,
          r = e.options,
          n = e.customFooter,
          s = e.filterList,
          l = e.components,
          i = void 0 === l ? {} : l,
          c = _filterInstanceProperty(r.textLabels);

      return React__default.createElement("div", {
        className: t.root
      }, React__default.createElement("div", {
        className: t.header
      }, React__default.createElement("div", {
        className: t.reset
      }, React__default.createElement(Typography, {
        variant: "body2",
        className: clsx(_defineProperty({}, t.title, !0))
      }, c.title), React__default.createElement(Button, {
        color: "primary",
        className: t.resetLink,
        tabIndex: 0,
        "aria-label": c.reset,
        "data-testid": "filterReset-button",
        onClick: this.resetFilters
      }, c.reset)), React__default.createElement("div", {
        className: t.filtersSelected
      })), React__default.createElement(core.Grid, {
        container: !0,
        direction: "row",
        justify: "flex-start",
        alignItems: "center",
        spacing: 4
      }, _mapInstanceProperty(o).call(o, function (e, t) {
        if (_filterInstanceProperty(e)) {
          var o = e.filterType || r.filterType;
          return "checkbox" === o ? a.renderCheckbox(e, t, i) : "multiselect" === o ? a.renderMultiselect(e, t, i) : "textField" === o ? a.renderTextField(e, t) : "custom" === o ? a.renderCustomField(e, t) : a.renderSelect(e, t);
        }
      })), n ? n(s, this.applyFilters) : "");
    }
  }]), o;
}(React__default.Component);

_defineProperty(TableFilter, "propTypes", {
  filterData: PropTypes.array.isRequired,
  filterList: PropTypes.array.isRequired,
  options: PropTypes.object.isRequired,
  onFilterUpdate: PropTypes.func,
  onFilterReset: PropTypes.func,
  classes: PropTypes.object
});

var DefaultTableFilter = styles.withStyles(defaultFilterStyles, {
  name: "MUIDataTableFilter"
})(TableFilter),
    TableFilterListItem = function TableFilterListItem(e) {
  var t = e.label,
      o = e.onDelete,
      a = e.className,
      r = e.filterProps;
  return (r = r || {}).className && (a = clsx(a, r.className)), React__default.createElement(Chip, _extends({
    label: t,
    onDelete: o,
    className: a
  }, r));
};

TableFilterListItem.propTypes = {
  label: PropTypes.node,
  onDelete: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired
};

var useStyles$2 = styles.makeStyles(function () {
  return {
    root: {
      display: "flex",
      justifyContent: "left",
      flexWrap: "wrap",
      margin: "0px 16px 0px 16px"
    },
    chip: {
      margin: "8px 8px 0px 0px"
    }
  };
}, {
  name: "MUIDataTableFilterList"
}),
    TableFilterList = function TableFilterList(e) {
  function s(t, e, o, a, r) {
    var n = 4 < arguments.length && void 0 !== r ? r : null,
        s = e;
    _Array$isArray(s) && 0 === s.length && (s = i[t]), c(t, e, o, a, n, function (e) {
      l.onFilterChipClose && l.onFilterChipClose(t, s, e);
    });
  }

  function a(e, t, o, a, r) {
    var n = r ? u[t] ? "custom" : "chip" : d[t].filterType;
    return React__default.createElement(f, {
      label: e,
      key: o,
      onDelete: function onDelete() {
        return s(t, a[o] || [], d[t].name, n, u[t]);
      },
      className: y.chip,
      itemKey: o,
      index: t,
      data: a,
      columnNames: d,
      filterProps: l.setFilterChipProps ? l.setFilterChipProps(t, d[t].name, a[o] || []) : {}
    });
  }

  function t(t) {
    return _mapInstanceProperty(t).call(t, function (o, n) {
      if ("custom" === d[n].filterType && t[n].length) {
        var e = p[n](o);
        return _Array$isArray(e) ? _mapInstanceProperty(e).call(e, function (e, t) {
          return a(e, n, t, o, !0);
        }) : a(e, n, n, o, !1);
      }

      return _mapInstanceProperty(o).call(o, function (e, t) {
        return o = n, a = e, r = t, React__default.createElement(f, {
          label: p[o](a),
          key: r,
          onDelete: function onDelete() {
            return s(o, a, d[o].name, "chip");
          },
          className: y.chip,
          itemKey: r,
          index: o,
          data: a,
          columnNames: d,
          filterProps: l.setFilterChipProps ? l.setFilterChipProps(o, d[o].name, a) : {}
        });
        var o, a, r;
      });
    });
  }

  var l = e.options,
      i = e.filterList,
      c = e.filterUpdate,
      p = e.filterListRenderers,
      d = e.columnNames,
      o = e.serverSideFilterList,
      u = e.customFilterListUpdate,
      r = e.ItemComponent,
      f = void 0 === r ? TableFilterListItem : r,
      y = useStyles$2(),
      n = l.serverSide;
  return React__default.createElement("div", {
    className: y.root
  }, t(n && o ? o : i));
};

TableFilterList.propTypes = {
  filterList: PropTypes.array.isRequired,
  filterListRenderers: PropTypes.array.isRequired,
  columnNames: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    name: PropTypes.string.isRequired,
    filterType: PropTypes.string
  })])).isRequired,
  onFilterUpdate: PropTypes.func,
  ItemComponent: PropTypes.any
};
var useStyles$3 = styles.makeStyles(function (e) {
  return {
    root: {
      color: e.palette.text.primary
    },
    caption: {
      flexShrink: 0
    },
    selectRoot: {
      marginRight: 32,
      marginLeft: 8
    },
    select: {
      paddingTop: 6,
      paddingBottom: 7,
      paddingLeft: 8,
      paddingRight: 24,
      textAlign: "right",
      textAlignLast: "right",
      fontSize: e.typography.pxToRem(14)
    },
    selectIcon: {},
    input: {
      color: "inhert",
      fontSize: "inhert",
      flexShrink: 0
    }
  };
}, {
  name: "MUIDataTableJumpToPage"
});

function JumpToPage(t) {
  for (var o = useStyles$3(), e = t.count, a = t.textLabels, r = t.rowsPerPage, n = t.page, s = (t.changePage, a.pagination.jumpToPage), l = [], i = Math.min(1e3, getPageValue(e, r, 1e6)), c = 0; c <= i; c++) l.push(c);

  var p = core.MenuItem;
  return React__default.createElement(core.Toolbar, {
    style: {
      display: "flex",
      minHeight: "52px",
      alignItems: "center"
    },
    className: o.root
  }, React__default.createElement(core.Typography, {
    color: "inherit",
    variant: "body2",
    className: o.caption
  }, s), React__default.createElement(core.Select, {
    classes: {
      select: o.select,
      icon: o.selectIcon
    },
    input: React__default.createElement(core.InputBase, {
      className: clsx(o.input, o.selectRoot)
    }),
    value: getPageValue(e, r, n),
    onChange: function onChange(e) {
      t.changePage(_parseInt(e.target.value, 10));
    },
    style: {
      marginRight: 0
    }
  }, _mapInstanceProperty(l).call(l, function (e) {
    return React__default.createElement(p, {
      className: o.menuItem,
      key: e,
      value: e
    }, e + 1);
  })));
}

JumpToPage.propTypes = {
  count: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  textLabels: PropTypes.object.isRequired
};
var useStyles$4 = styles.makeStyles(function (e) {
  return {
    root: {},
    tableCellContainer: {
      padding: "0px 24px 0px 24px"
    },
    navContainer: {
      display: "flex",
      justifyContent: "flex-end"
    },
    toolbar: {},
    selectRoot: {},
    "@media screen and (max-width: 400px)": {
      toolbar: {
        "& span:nth-child(2)": {
          display: "none"
        }
      },
      selectRoot: {
        marginRight: "8px"
      }
    }
  };
}, {
  name: "MUIDataTablePagination"
});

function TablePagination(o) {
  var e = useStyles$4(),
      t = o.count,
      a = o.options,
      r = o.rowsPerPage,
      n = o.page,
      l = a.textLabels.pagination;
  return React__default.createElement(MuiTableFooter, null, React__default.createElement(TableRow, null, React__default.createElement(TableCell, {
    colSpan: "1000",
    className: e.tableCellContainer
  }, React__default.createElement("div", {
    className: e.navContainer
  }, a.jumpToPage ? React__default.createElement(JumpToPage, {
    count: t,
    page: n,
    rowsPerPage: r,
    textLabels: a.textLabels,
    changePage: o.changePage,
    changeRowsPerPage: o.changeRowsPerPage
  }) : null, React__default.createElement(MuiTablePagination, {
    component: "div",
    className: e.root,
    classes: {
      caption: e.caption,
      toolbar: e.toolbar,
      selectRoot: e.selectRoot
    },
    count: t,
    rowsPerPage: r,
    page: getPageValue(t, r, n),
    labelRowsPerPage: l.rowsPerPage,
    labelDisplayedRows: function labelDisplayedRows(e) {
      var t,
          o,
          a,
          r = e.from,
          n = e.to,
          s = e.count;
      return _concatInstanceProperty(t = _concatInstanceProperty(o = _concatInstanceProperty(a = "".concat(r, "-")).call(a, n, " ")).call(o, l.displayRows, " ")).call(t, s);
    },
    backIconButtonProps: {
      id: "pagination-back",
      "data-testid": "pagination-back",
      "aria-label": l.previous,
      title: l.previous || ""
    },
    nextIconButtonProps: {
      id: "pagination-next",
      "data-testid": "pagination-next",
      "aria-label": l.next,
      title: l.next || ""
    },
    SelectProps: {
      id: "pagination-input",
      SelectDisplayProps: {
        id: "pagination-rows",
        "data-testid": "pagination-rows"
      },
      MenuProps: {
        id: "pagination-menu",
        "data-testid": "pagination-menu",
        MenuListProps: {
          id: "pagination-menu-list",
          "data-testid": "pagination-menu-list"
        }
      }
    },
    rowsPerPageOptions: a.rowsPerPageOptions,
    onChangePage: function onChangePage(e, t) {
      o.changePage(t);
    },
    onChangeRowsPerPage: function onChangeRowsPerPage(e) {
      o.changeRowsPerPage(e.target.value);
    }
  })))));
}

TablePagination.propTypes = {
  count: PropTypes.number.isRequired,
  options: PropTypes.object.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  changeRowsPerPage: PropTypes.func.isRequired
};

var useStyles$5 = styles.makeStyles(function () {
  return {
    root: {
      "@media print": {
        display: "none"
      }
    }
  };
}, {
  name: "MUIDataTableFooter"
}),
    TableFooter = function TableFooter(e) {
  var t = e.options,
      o = e.rowCount,
      a = e.page,
      r = e.rowsPerPage,
      n = e.changeRowsPerPage,
      s = e.changePage,
      l = useStyles$5(),
      i = t.customFooter,
      c = t.pagination,
      p = void 0 === c || c;
  return i ? React__default.createElement(MuiTable, {
    className: l.root
  }, t.customFooter(o, a, r, n, s, t.textLabels.pagination)) : p ? React__default.createElement(MuiTable, {
    className: l.root
  }, React__default.createElement(TablePagination, {
    count: o,
    page: a,
    rowsPerPage: r,
    changeRowsPerPage: n,
    changePage: s,
    component: "div",
    options: t
  })) : null;
};

TableFooter.propTypes = {
  rowCount: PropTypes.number.isRequired,
  options: PropTypes.shape({
    customFooter: PropTypes.func,
    pagination: PropTypes.bool,
    textLabels: PropTypes.shape({
      pagination: PropTypes.object
    })
  }),
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  changeRowsPerPage: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired
};

var getColModel = function getColModel(n, e, s) {
  var t,
      l = [],
      i = n[0] ? n[0] : null;
  null === i && (i = {
    offsetLeft: 1 / 0
  }, t = _Object$entries(n), _forEachInstanceProperty(t).call(t, function (e, t) {
    var o = _slicedToArray(e, 2),
        a = (o[0], o[1]);

    a && a.offsetLeft < i.offsetLeft && (i = a);
  }), i.offsetLeft === 1 / 0 && (i = {
    offsetParent: 0,
    offsetWidth: 0,
    offsetLeft: 0
  }));

  for (var o = 0, c = 0, a = i.offsetParent; a && (c = c + (a.offsetLeft || 0) - (a.scrollLeft || 0), a = a.offsetParent, !(1e3 < ++o)););

  return n[0] && (l[0] = {
    left: c + i.offsetLeft,
    width: i.offsetWidth,
    columnIndex: null,
    ref: i
  }), _forEachInstanceProperty(e).call(e, function (e, t) {
    var o,
        a = n[e + 1],
        r = l.length - 1;
    s[e] && "true" !== s[e].display || (o = -1 != r ? l[r].left + l[r].width : c + i.offsetLeft, l.push({
      left: o,
      width: a.offsetWidth,
      columnIndex: e,
      ref: a
    }));
  }), l;
},
    reorderColumns = function reorderColumns(e, t, o) {
  var a,
      r,
      n,
      s = _sliceInstanceProperty(e).call(e),
      l = _indexOfInstanceProperty(s).call(s, t),
      i = _indexOfInstanceProperty(s).call(s, o);

  return -1 !== l && -1 !== i && (n = s[l], s = _concatInstanceProperty(a = []).call(a, _toConsumableArray(_sliceInstanceProperty(s).call(s, 0, l)), _toConsumableArray(_sliceInstanceProperty(s).call(s, l + 1))), s = _concatInstanceProperty(r = []).call(r, _toConsumableArray(_sliceInstanceProperty(s).call(s, 0, i)), [n], _toConsumableArray(_sliceInstanceProperty(s).call(s, i)))), s;
},
    handleHover = function handleHover(e) {
  e.item;
  var t = e.mon,
      o = e.index,
      a = e.headCellRefs,
      r = e.updateColumnOrder,
      n = e.columnOrder,
      s = e.transitionTime,
      l = void 0 === s ? 300 : s,
      i = e.tableRef,
      c = e.tableId,
      p = e.timers,
      d = e.columns,
      u = t.getItem().colIndex;

  if (a === t.getItem().headCellRefs && u !== o) {
    for (var f = reorderColumns(n, t.getItem().colIndex, o), y = getColModel(a, f, d), b = t.getClientOffset().x, h = -1, m = 0; m < y.length; m++) if (b > y[m].left && b < y[m].left + y[m].width) {
      h = y[m].columnIndex;
      break;
    }

    if (h === t.getItem().colIndex) {
      clearTimeout(p.columnShift);

      var _ = getColModel(a, n, d),
          g = [];

      _forEachInstanceProperty(y).call(y, function (e) {
        g[e.columnIndex] = e.left;
      }), _forEachInstanceProperty(_).call(_, function (e) {
        g[e.columnIndex] = g[e.columnIndex] - e.left;
      });

      for (var P = 1; P < n.length; P++) {
        var T = n[P];
        d[T] && "true" !== d[T].display || (a[P] && (a[P].style.transition = "280ms"), a[P] && (a[P].style.transform = "translateX(" + g[P - 1] + "px)"));
      }

      for (var R = [], x = [], v = 0; v < n.length; v++) {
        for (var w = i ? i.querySelectorAll('[data-colindex="' + v + '"][data-tableid="' + c + '"]') : [], I = 0; I < w.length; I++) w[I].style.transition = l + "ms", w[I].style.transform = "translateX(" + g[v] + "px)", R.push(w[I]);

        for (var C = i ? i.querySelectorAll('[data-divider-index="' + (v + 1) + '"][data-tableid="' + c + '"]') : [], S = 0; S < C.length; S++) C[S].style.transition = l + "ms", C[S].style.transform = "translateX(" + g[n[v]] + "px)", x.push(C[S]);
      }

      var D = t.getItem().colIndex;
      p.columnShift = _setTimeout(function () {
        _forEachInstanceProperty(R).call(R, function (e) {
          e.style.transition = "0s", e.style.transform = "translateX(0)";
        }), _forEachInstanceProperty(x).call(x, function (e) {
          e.style.transition = "0s", e.style.transform = "translateX(0)";
        }), r(f, D, o);
      }, l);
    }
  }
},
    useColumnDrop = function useColumnDrop(o) {
  var e = reactDnd.useDrop({
    accept: "HEADER",
    drop: r,
    hover: function hover(e, t) {
      return handleHover(_Object$assign({}, o, {
        item: e,
        mon: t
      }));
    },
    collect: function collect(e) {
      return {
        isOver: !!e.isOver(),
        canDrop: !!e.canDrop()
      };
    }
  }),
      t = _slicedToArray(e, 2),
      a = t[0],
      r = (a.isOver, a.canDrop, t[1]);

  return [r];
};

function ownKeys(t, e) {
  var o,
      a = _Object$keys(t);

  return _Object$getOwnPropertySymbols && (o = _Object$getOwnPropertySymbols(t), e && (o = _filterInstanceProperty(o).call(o, function (e) {
    return _Object$getOwnPropertyDescriptor(t, e).enumerable;
  })), a.push.apply(a, o)), a;
}

function _objectSpread(t) {
  for (var e = 1; e < arguments.length; e++) {
    var o,
        a,
        r = null != arguments[e] ? arguments[e] : {};
    e % 2 ? _forEachInstanceProperty(o = ownKeys(Object(r), !0)).call(o, function (e) {
      _defineProperty(t, e, r[e]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(t, _Object$getOwnPropertyDescriptors(r)) : _forEachInstanceProperty(a = ownKeys(Object(r))).call(a, function (e) {
      _Object$defineProperty(t, e, _Object$getOwnPropertyDescriptor(r, e));
    });
  }

  return t;
}

var useStyles$6 = styles.makeStyles(function (e) {
  return {
    root: {},
    fixedHeader: {
      position: "sticky",
      top: "0px",
      zIndex: 100,
      backgroundColor: e.palette.background.paper
    },
    tooltip: {
      cursor: "pointer"
    },
    mypopper: {
      "&[data-x-out-of-boundaries]": {
        display: "none"
      }
    },
    data: {
      display: "inline-block"
    },
    sortAction: {
      display: "flex",
      cursor: "pointer"
    },
    dragCursor: {
      cursor: "grab"
    },
    sortLabelRoot: {
      height: "20px"
    },
    sortActive: {
      color: e.palette.text.primary
    },
    toolButton: {
      textTransform: "none",
      marginLeft: "-8px",
      minWidth: 0,
      marginRight: "8px"
    },
    contentWrapper: {
      display: "flex",
      alignItems: "center"
    },
    hintIconAlone: {
      marginTop: "-3px",
      marginLeft: "3px"
    },
    hintIconWithSortIcon: {
      marginTop: "-3px"
    }
  };
}, {
  name: "MUIDataTableHeadCell"
}),
    TableHeadCell = function TableHeadCell(e) {
  function t() {
    return !!b && _.draggableColumns && _.draggableColumns.enabled && !1 !== i.draggable;
  }

  var o,
      a,
      r = e.cellHeaderProps,
      n = void 0 === r ? {} : r,
      s = e.children,
      l = e.colPosition,
      i = e.column,
      c = e.columns,
      p = e.columnOrder,
      d = void 0 === p ? [] : p,
      u = e.components,
      f = void 0 === u ? {} : u,
      y = e.draggableHeadCellRefs,
      b = e.draggingHook,
      h = e.hint,
      m = e.index,
      _ = e.options,
      g = e.print,
      P = e.setCellRef,
      T = _sortInstanceProperty(e),
      R = e.sortDirection,
      x = e.tableRef,
      v = e.tableId,
      w = e.timers,
      I = e.toggleSort,
      C = e.updateColumnOrder,
      S = React.useState(!1),
      D = _slicedToArray(S, 2),
      O = D[0],
      k = D[1],
      E = React.useState(!1),
      L = _slicedToArray(E, 2),
      F = L[0],
      j = L[1],
      A = useStyles$6(),
      $ = _slicedToArray(b || [], 2),
      H = $[0],
      z = $[1],
      N = n.className,
      B = _objectWithoutProperties(n, ["className"]),
      q = f.Tooltip || MuiTooltip,
      M = "none" !== R && void 0 !== R,
      W = "none" !== R && R,
      U = _objectSpread({
    classes: {
      root: A.sortLabelRoot
    },
    tabIndex: -1,
    active: M,
    hideSortIcon: !0
  }, W ? {
    direction: R
  } : {}),
      V = reactDnd.useDrag({
    item: {
      type: "HEADER",
      colIndex: m,
      headCellRefs: y
    },
    begin: function begin() {
      return _setTimeout(function () {
        j(!1), k(!1), z(!0);
      }, 0), null;
    },
    end: function end() {
      z(!1);
    },
    collect: function collect(e) {
      return {
        opacity: e.isDragging() ? 1 : 0
      };
    }
  }),
      K = _slicedToArray(V, 3),
      G = (K[0].opacity, K[1]),
      X = (K[2], useColumnDrop({
    drop: function drop() {
      k(!1), j(!1), z(!1);
    },
    index: m,
    headCellRefs: y,
    updateColumnOrder: C,
    columnOrder: d,
    columns: c,
    transitionTime: _.draggableColumns ? _.draggableColumns.transitionTime : 300,
    tableRef: x ? x() : null,
    tableId: v || "none",
    timers: w
  })),
      J = _slicedToArray(X, 1)[0],
      Q = clsx((_defineProperty(o = {}, A.root, !0), _defineProperty(o, A.fixedHeader, _.fixedHeader), _defineProperty(o, "datatables-noprint", !g), _defineProperty(o, N, N), o));

  return React__default.createElement(TableCell, _extends({
    ref: function ref(e) {
      J && J(e), P && P(m + 1, l + 1, e);
    },
    className: Q,
    scope: "col",
    sortDirection: W,
    "data-colindex": m,
    "data-tableid": v,
    onMouseDown: function onMouseDown() {
      k(!1);
    }
  }, B), _sortInstanceProperty(_) && T ? React__default.createElement("span", {
    className: A.contentWrapper
  }, React__default.createElement(q, {
    title: !H && _.textLabels ? _.textLabels.body.columnHeaderTooltip ? _.textLabels.body.columnHeaderTooltip(i) : _.textLabels.body.toolTip : "",
    placement: "bottom",
    open: O,
    onOpen: function onOpen() {
      return k(!H);
    },
    onClose: function onClose() {
      return k(!1);
    },
    classes: {
      tooltip: A.tooltip,
      popper: A.mypopper
    }
  }, React__default.createElement(Button, {
    variant: "text",
    onKeyUp: function onKeyUp(e) {
      return "Enter" === e.key && I(m), !1;
    },
    onClick: function onClick() {
      I(m);
    },
    className: A.toolButton,
    "data-testid": "headcol-".concat(m),
    ref: t() ? G : null
  }, React__default.createElement("div", {
    className: A.sortAction
  }, React__default.createElement("div", {
    className: clsx((_defineProperty(a = {}, A.data, !0), _defineProperty(a, A.sortActive, M), _defineProperty(a, A.dragCursor, t()), a))
  }, s), React__default.createElement("div", {
    className: A.sortAction
  }, React__default.createElement(TableSortLabel, U))))), h && React__default.createElement(q, {
    title: h
  }, React__default.createElement(HelpIcon, {
    className: M ? A.hintIconWithSortIcon : A.hintIconAlone,
    fontSize: "small"
  }))) : React__default.createElement("div", {
    className: h ? A.sortAction : null,
    ref: t() ? G : null
  }, s, h && React__default.createElement(q, {
    title: h,
    placement: "bottom-end",
    open: F,
    onOpen: function onOpen() {
      return k(!1), void j(!0);
    },
    onClose: function onClose() {
      return j(!1);
    },
    classes: {
      tooltip: A.tooltip,
      popper: A.mypopper
    },
    enterDelay: 300
  }, React__default.createElement(HelpIcon, {
    className: A.hintIconAlone,
    fontSize: "small"
  }))));
};

TableHeadCell.propTypes = {
  options: PropTypes.object.isRequired,
  sortDirection: PropTypes.oneOf(["asc", "desc", "none"]),
  toggleSort: PropTypes.func.isRequired,
  sort: PropTypes.bool.isRequired,
  hint: PropTypes.string,
  print: PropTypes.bool.isRequired,
  column: PropTypes.object,
  components: PropTypes.object
};

var useStyles$7 = styles.makeStyles(function () {
  return {
    root: {}
  };
}, {
  name: "MUIDataTableHeadRow"
}),
    TableHeadRow = function TableHeadRow(e) {
  var t = e.children,
      o = useStyles$7();
  return React__default.createElement(TableRow, {
    className: clsx(_defineProperty({}, o.root, !0))
  }, t);
};

function ownKeys$1(t, e) {
  var o,
      a = _Object$keys(t);

  return _Object$getOwnPropertySymbols && (o = _Object$getOwnPropertySymbols(t), e && (o = _filterInstanceProperty(o).call(o, function (e) {
    return _Object$getOwnPropertyDescriptor(t, e).enumerable;
  })), a.push.apply(a, o)), a;
}

function _objectSpread$1(t) {
  for (var e = 1; e < arguments.length; e++) {
    var o,
        a,
        r = null != arguments[e] ? arguments[e] : {};
    e % 2 ? _forEachInstanceProperty(o = ownKeys$1(Object(r), !0)).call(o, function (e) {
      _defineProperty(t, e, r[e]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(t, _Object$getOwnPropertyDescriptors(r)) : _forEachInstanceProperty(a = ownKeys$1(Object(r))).call(a, function (e) {
      _Object$defineProperty(t, e, _Object$getOwnPropertyDescriptor(r, e));
    });
  }

  return t;
}

TableHeadRow.propTypes = {
  children: PropTypes.node
};

var useStyles$8 = styles.makeStyles(function (e) {
  return {
    main: {},
    responsiveStacked: _defineProperty({}, e.breakpoints.down("sm"), {
      display: "none"
    }),
    responsiveStackedAlways: {
      display: "none"
    },
    responsiveSimple: _defineProperty({}, e.breakpoints.down("xs"), {
      display: "none"
    })
  };
}, {
  name: "MUIDataTableHead"
}),
    TableHead = function TableHead(e) {
  var t,
      o = e.columnOrder,
      r = void 0 === o ? null : o,
      n = e.columns,
      a = e.components,
      s = void 0 === a ? {} : a,
      l = e.count,
      i = e.data,
      c = e.draggableHeadCellRefs,
      p = e.expandedRows,
      d = e.options,
      u = e.selectedRows,
      f = e.selectRowUpdate,
      y = e.setCellRef,
      b = e.sortOrder,
      h = void 0 === b ? {} : b,
      m = e.tableRef,
      _ = e.tableId,
      g = e.timers,
      P = e.toggleAllExpandableRows,
      T = e.toggleSort,
      R = e.updateColumnOrder,
      x = useStyles$8();
  null === r && (r = n ? _mapInstanceProperty(n).call(n, function (e, t) {
    return t;
  }) : []);

  function v(e) {
    T(e);
  }

  function w() {
    f("head", null);
  }

  var I = React.useState(!1),
      C = _slicedToArray(I, 2),
      S = C[0],
      D = C[1],
      O = u && u.data.length || 0,
      k = 0 < O && O < l,
      E = 0 < O && l <= O;

  if (!0 === d.disableToolbarSelect || "none" === d.selectToolbarPlacement || "above" === d.selectToolbarPlacement) if (E) {
    for (var L = 0; L < i.length; L++) if (!u.lookup[i[L].dataIndex]) {
      k = !(E = !1);
      break;
    }
  } else l < O && (k = !0);

  var F = _mapInstanceProperty(r).call(r, function (e, t) {
    return {
      column: n[e],
      index: e,
      colPos: t
    };
  });

  return React__default.createElement(core.TableHead, {
    className: clsx((_defineProperty(t = {}, x.responsiveStacked, "vertical" === d.responsive || "stacked" === d.responsive || "stackedFullWidth" === d.responsive), _defineProperty(t, x.responsiveStackedAlways, "verticalAlways" === d.responsive), _defineProperty(t, x.responsiveSimple, "simple" === d.responsive), _defineProperty(t, x.main, !0), t))
  }, React__default.createElement(TableHeadRow, null, React__default.createElement(TableSelectCell, {
    setHeadCellRef: y,
    onChange: _bindInstanceProperty(w).call(w, null),
    indeterminate: k,
    checked: E,
    isHeaderCell: !0,
    expandedRows: p,
    expandableRowsHeader: d.expandableRowsHeader,
    expandableOn: d.expandableRows,
    selectableOn: d.selectableRows,
    fixedHeader: d.fixedHeader,
    fixedSelectColumn: d.fixedSelectColumn,
    selectableRowsHeader: d.selectableRowsHeader,
    selectableRowsHideCheckboxes: d.selectableRowsHideCheckboxes,
    onExpand: P,
    isRowSelectable: !0,
    components: s
  }), _mapInstanceProperty(F).call(F, function (e) {
    var t = e.column,
        o = e.index,
        a = e.colPos;
    return "true" === t.display && (t.customHeadRender ? t.customHeadRender(_objectSpread$1({
      index: o
    }, t), v, h) : React__default.createElement(TableHeadCell, {
      cellHeaderProps: n[o].setCellHeaderProps && n[o].setCellHeaderProps(_objectSpread$1({
        index: o
      }, t)) || {},
      key: o,
      index: o,
      colPosition: a,
      type: "cell",
      setCellRef: y,
      sort: _sortInstanceProperty(t),
      sortDirection: t.name === h.name ? h.direction : "none",
      toggleSort: v,
      hint: t.hint,
      print: t.print,
      options: d,
      column: t,
      columns: n,
      updateColumnOrder: R,
      columnOrder: r,
      timers: g,
      draggingHook: [S, D],
      draggableHeadCellRefs: c,
      tableRef: m,
      tableId: _,
      components: s
    }, t.customHeadLabelRender ? t.customHeadLabelRender(_objectSpread$1({
      index: o,
      colPos: a
    }, t)) : t.label));
  })));
};

function ownKeys$2(t, e) {
  var o,
      a = _Object$keys(t);

  return _Object$getOwnPropertySymbols && (o = _Object$getOwnPropertySymbols(t), e && (o = _filterInstanceProperty(o).call(o, function (e) {
    return _Object$getOwnPropertyDescriptor(t, e).enumerable;
  })), a.push.apply(a, o)), a;
}

function _objectSpread$2(t) {
  for (var e = 1; e < arguments.length; e++) {
    var o,
        a,
        r = null != arguments[e] ? arguments[e] : {};
    e % 2 ? _forEachInstanceProperty(o = ownKeys$2(Object(r), !0)).call(o, function (e) {
      _defineProperty(t, e, r[e]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(t, _Object$getOwnPropertyDescriptors(r)) : _forEachInstanceProperty(a = ownKeys$2(Object(r))).call(a, function (e) {
      _Object$defineProperty(t, e, _Object$getOwnPropertyDescriptor(r, e));
    });
  }

  return t;
}

function _createSuper$3(a) {
  var r = _isNativeReflectConstruct$3();

  return function () {
    var e,
        t,
        o = _getPrototypeOf(a);

    return t = r ? (e = _getPrototypeOf(this).constructor, _Reflect$construct(o, arguments, e)) : o.apply(this, arguments), _possibleConstructorReturn(this, t);
  };
}

function _isNativeReflectConstruct$3() {
  if ("undefined" == typeof Reflect || !_Reflect$construct) return !1;
  if (_Reflect$construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

var defaultResizeStyles = {
  root: {
    position: "absolute"
  },
  resizer: {
    position: "absolute",
    width: "1px",
    height: "100%",
    left: "100px",
    cursor: "ew-resize",
    border: "0.1px solid rgba(224, 224, 224, 1)"
  }
};

function getParentOffsetLeft(e) {
  for (var t = 0, o = 0, a = e.offsetParent; a && (o = o + (a.offsetLeft || 0) - (a.scrollLeft || 0), a = a.offsetParent, !(1e3 < ++t)););

  return o;
}

var TableResize = function (e) {
  _inherits(n, e);

  var r = _createSuper$3(n);

  function n() {
    var e, I;

    _classCallCheck(this, n);

    for (var t = arguments.length, o = new Array(t), a = 0; a < t; a++) o[a] = arguments[a];

    return I = r.call.apply(r, _concatInstanceProperty(e = [this]).call(e, o)), _defineProperty(_assertThisInitialized(I), "state", {
      resizeCoords: {},
      priorPosition: {},
      tableWidth: "100%",
      tableHeight: "100%"
    }), _defineProperty(_assertThisInitialized(I), "handleResize", function () {
      window.innerWidth !== I.windowWidth && (I.windowWidth = window.innerWidth, I.setDividers());
    }), _defineProperty(_assertThisInitialized(I), "setCellRefs", function (e, t) {
      I.cellsRef = e, I.tableRef = t, I.setDividers();
    }), _defineProperty(_assertThisInitialized(I), "setDividers", function () {
      var e = I.tableRef,
          t = e.getBoundingClientRect(),
          o = t.width,
          a = t.height,
          s = I.state.resizeCoords;

      for (var r in s) delete s[r];

      var l = getParentOffsetLeft(e),
          n = _Object$entries(I.cellsRef);

      _forEachInstanceProperty(n).call(n, function (e, t) {
        var o,
            a = _slicedToArray(e, 2),
            r = a[0],
            n = a[1];

        n && (o = ((o = n.getBoundingClientRect().left) || 0) - l, window.getComputedStyle(n, null), s[r] = {
          left: o + n.offsetWidth
        });
      }), I.setState({
        tableWidth: o,
        tableHeight: a,
        resizeCoords: s
      }, I.updateWidths);
    }), _defineProperty(_assertThisInitialized(I), "updateWidths", function () {
      var e,
          s = 0,
          t = I.state,
          o = t.resizeCoords,
          l = t.tableWidth;

      _forEachInstanceProperty(e = _Object$entries(o)).call(e, function (e) {
        var t = _slicedToArray(e, 2),
            o = t[0],
            a = t[1],
            r = Number((a.left - s) / l * 100);

        "object" === _typeof(I.props.resizableColumns) && I.props.resizableColumns.roundWidthPercentages && (r = r.toFixed(2)), s = a.left;
        var n = I.cellsRef[o];
        n && (n.style.width = r + "%");
      });
    }), _defineProperty(_assertThisInitialized(I), "onResizeStart", function (e, t) {
      var o = I.tableRef,
          a = o.style.width,
          s = 0;
      o.style.width = "1px";

      var r = _Object$entries(I.cellsRef);

      _forEachInstanceProperty(r).call(r, function (e, t) {
        var o = _slicedToArray(e, 2),
            a = o[0],
            r = o[1],
            n = r ? r.getBoundingClientRect() : {
          width: 0,
          left: 0
        };

        I.minWidths[a] = n.width, s = Math.max(a, s);
      }), o.style.width = a, I.setState({
        isResize: !0,
        id: e,
        lastColumn: s
      });
    }), _defineProperty(_assertThisInitialized(I), "onResizeMove", function (e, t) {
      function r(e) {
        for (var t = e + 1, o = 0; void 0 === b[t] && o < 20;) t++, o++;

        return b[t];
      }

      function n(e) {
        for (var t = e - 1; void 0 === b[t] && 0 <= t;) t--;

        return b[t];
      }

      var o,
          a,
          s,
          l,
          i,
          c,
          p,
          d,
          u,
          f = I.state,
          y = f.isResize,
          b = f.resizeCoords,
          h = f.lastColumn,
          m = I.minWidths[e],
          _ = I.minWidths[function (e) {
        for (var t = e + 1, o = 0; void 0 === b[t] && o < 20;) t++, o++;

        return t;
      }(_parseInt(e, 10))] || I.minWidths[e],
          g = _parseInt(e, 10),
          P = (_Object$entries(I.cellsRef), I.tableRef),
          T = P.getBoundingClientRect(),
          R = T.width,
          x = T.height,
          v = I.props.options.selectableRows,
          w = getParentOffsetLeft(P);

      y && (o = t.clientX - w, a = function a(e, t, o) {
        return t - o < e ? t - o : e;
      }, s = function s(e, t) {
        return e < t ? t : e;
      }, l = function l(e, t, o, a) {
        return void 0 !== r(o) && e > r(o).left - a ? r(o).left - a : e;
      }, i = function i(e, t, o, a) {
        return void 0 !== n(o) && e < n(o).left + a ? n(o).left + a : e;
      }, p = function p(e) {
        return e === function (e) {
          for (var t = e - 1; void 0 === b[t] && 0 <= t;) t--;

          return t;
        }(h);
      }, (c = function c(e, t) {
        for (var o = 1; !b[o] && o < 20;) o++;

        return "none" !== e && 0 === t || "none" === e && t === o;
      })(v, g) && p(g) ? o = a(o = s(o, m), R, _) : !c(v, g) && p(g) ? o = i(o = a(o, R, _), 0, g, m) : c(v, g) && !p(g) ? o = l(o = s(o, m), 0, g, _) : c(v, g) || p(g) || (o = l(o = i(o, 0, g, m), 0, g, _)), d = _objectSpread$2(_objectSpread$2({}, b[e]), {}, {
        left: o
      }), u = _objectSpread$2(_objectSpread$2({}, b), {}, _defineProperty({}, e, d)), I.setState({
        resizeCoords: u,
        tableHeight: x
      }, I.updateWidths));
    }), _defineProperty(_assertThisInitialized(I), "onResizeEnd", function (e, t) {
      I.setState({
        isResize: !1,
        id: null
      });
    }), I;
  }

  return _createClass(n, [{
    key: "componentDidMount",
    value: function value() {
      var e = this;
      this.minWidths = [], this.windowWidth = null, this.props.setResizeable(this.setCellRefs), this.props.updateDividers(function () {
        return e.setState({
          updateCoords: !0
        }, function () {
          return e.updateWidths;
        });
      }), window.addEventListener("resize", this.handleResize, !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      window.removeEventListener("resize", this.handleResize, !1);
    }
  }, {
    key: "render",
    value: function value() {
      var e,
          l = this,
          t = this.props,
          i = t.classes,
          c = t.tableId,
          o = this.state,
          p = o.id,
          d = o.isResize,
          a = o.resizeCoords,
          u = o.tableWidth,
          f = o.tableHeight;
      return React__default.createElement("div", {
        className: i.root,
        style: {
          width: u
        }
      }, _mapInstanceProperty(e = _Object$entries(a)).call(e, function (e) {
        var t,
            o,
            a,
            r = _slicedToArray(e, 2),
            n = r[0],
            s = r[1];

        return React__default.createElement("div", {
          "data-divider-index": n,
          "data-tableid": c,
          "aria-hidden": "true",
          key: n,
          onMouseMove: _bindInstanceProperty(t = l.onResizeMove).call(t, null, n),
          onMouseUp: _bindInstanceProperty(o = l.onResizeEnd).call(o, null, n),
          style: {
            width: d && p == n ? u : "auto",
            position: "absolute",
            height: f - 2,
            cursor: "ew-resize",
            zIndex: 1e3
          }
        }, React__default.createElement("div", {
          "aria-hidden": "true",
          onMouseDown: _bindInstanceProperty(a = l.onResizeStart).call(a, null, n),
          className: i.resizer,
          style: {
            left: s.left
          }
        }));
      }));
    }
  }]), n;
}(React__default.Component);

_defineProperty(TableResize, "propTypes", {
  classes: PropTypes.object
});

var DefaultTableResize = styles.withStyles(defaultResizeStyles, {
  name: "MUIDataTableResize"
})(TableResize),
    Popover = function Popover(e) {
  e.className;

  var o = e.trigger,
      t = e.refExit,
      a = e.hide,
      r = e.content,
      n = _objectWithoutProperties(e, ["className", "trigger", "refExit", "hide", "content"]),
      s = React.useState(!1),
      l = _slicedToArray(s, 2),
      i = l[0],
      c = l[1],
      p = React.useRef(null);

  React.useEffect(function () {
    i && "boolean" == typeof a && a && c(!1);
  }, [a, i, c]);

  function d() {
    c(!1);
  }

  var u = n.classes.closeIcon;
  delete n.classes.closeIcon;
  var f = {
    key: "content",
    onClick: function onClick(e) {
      var t;
      o.props.onClick && o.props.onClick(), t = e, p.current = t.currentTarget, c(!0);
    }
  };
  return React__default.createElement(React__default.Fragment, null, React__default.createElement("span", f, o), React__default.createElement(MuiPopover, _extends({
    elevation: 2,
    open: i,
    onClose: d,
    onExited: function onExited() {
      t && t();
    },
    anchorEl: p.current,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center"
    }
  }, n), React__default.createElement(IconButton, {
    "aria-label": "Close",
    onClick: d,
    className: u,
    style: {
      position: "absolute",
      right: "4px",
      top: "4px",
      zIndex: "1000"
    }
  }, React__default.createElement(CloseIcon, null)), r));
};

Popover.propTypes = {
  refExit: PropTypes.func,
  trigger: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired,
  hide: PropTypes.bool
};

var useStyles$9 = styles.makeStyles(function (e) {
  return {
    root: {
      padding: "16px 24px 16px 24px",
      fontFamily: "Roboto"
    },
    title: {
      marginLeft: "-7px",
      marginRight: "24px",
      fontSize: "14px",
      color: e.palette.text.secondary,
      textAlign: "left",
      fontWeight: 500
    },
    formGroup: {
      marginTop: "8px"
    },
    formControl: {},
    checkbox: {
      padding: "0px",
      width: "32px",
      height: "32px"
    },
    checkboxRoot: {},
    checked: {},
    label: {
      fontSize: "15px",
      marginLeft: "8px",
      color: e.palette.text.primary
    }
  };
}, {
  name: "MUIDataTableViewCol"
}),
    TableViewCol = function TableViewCol(e) {
  var t = e.columns,
      o = e.options,
      a = e.components,
      r = void 0 === a ? {} : a,
      n = e.onColumnUpdate,
      s = (e.updateColumns, useStyles$9()),
      l = o.textLabels.viewColumns,
      i = r.Checkbox || Checkbox;
  return React__default.createElement(FormControl, {
    component: "fieldset",
    className: s.root,
    "aria-label": l.titleAria
  }, React__default.createElement(Typography, {
    variant: "caption",
    className: s.title
  }, l.title), React__default.createElement(FormGroup, {
    className: s.formGroup
  }, _mapInstanceProperty(t).call(t, function (e, t) {
    return "excluded" !== e.display && !1 !== e.viewColumns && React__default.createElement(FormControlLabel, {
      key: t,
      classes: {
        root: s.formControl,
        label: s.label
      },
      control: React__default.createElement(i, {
        color: "primary",
        "data-description": "table-view-col",
        className: s.checkbox,
        classes: {
          root: s.checkboxRoot,
          checked: s.checked
        },
        onChange: function onChange() {
          n(t);
        },
        checked: "true" === e.display,
        value: e.name
      }),
      label: e.label
    });
  })));
};

TableViewCol.propTypes = {
  columns: PropTypes.array.isRequired,
  options: PropTypes.object.isRequired,
  onColumnUpdate: PropTypes.func,
  classes: PropTypes.object
};

var useStyles$a = styles.makeStyles(function (e) {
  return {
    main: {
      display: "flex",
      flex: "1 0 auto"
    },
    searchIcon: {
      color: e.palette.text.secondary,
      marginTop: "10px",
      marginRight: "8px"
    },
    searchText: {
      flex: "0.8 0"
    },
    clearIcon: {
      "&:hover": {
        color: e.palette.error.main
      }
    }
  };
}, {
  name: "MUIDataTableSearch"
}),
    TableSearch = function TableSearch(e) {
  var t = e.options,
      o = e.searchText,
      a = e.onSearch,
      r = e.onHide,
      n = useStyles$a();
  return React__default.createElement(Grow, {
    appear: !0,
    in: !0,
    timeout: 300
  }, React__default.createElement("div", {
    className: n.main
  }, React__default.createElement(SearchIcon, {
    className: n.searchIcon
  }), React__default.createElement(TextField, _extends({
    className: n.searchText,
    autoFocus: !0,
    InputProps: {
      "data-test-id": t.textLabels.toolbar.search
    },
    inputProps: {
      "aria-label": t.textLabels.toolbar.search
    },
    value: o || "",
    onKeyDown: function onKeyDown(e) {
      "Escape" === e.key && r();
    },
    onChange: function onChange(e) {
      a(e.target.value);
    },
    fullWidth: !0,
    placeholder: t.searchPlaceholder
  }, t.searchProps ? t.searchProps : {})), React__default.createElement(IconButton, {
    className: n.clearIcon,
    onClick: r
  }, React__default.createElement(ClearIcon, null))));
};

function _createSuper$4(a) {
  var r = _isNativeReflectConstruct$4();

  return function () {
    var e,
        t,
        o = _getPrototypeOf(a);

    return t = r ? (e = _getPrototypeOf(this).constructor, _Reflect$construct(o, arguments, e)) : o.apply(this, arguments), _possibleConstructorReturn(this, t);
  };
}

function _isNativeReflectConstruct$4() {
  if ("undefined" == typeof Reflect || !_Reflect$construct) return !1;
  if (_Reflect$construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

var defaultToolbarStyles = function defaultToolbarStyles(e) {
  var t = {
    root: {
      "@media print": {
        display: "none"
      }
    },
    fullWidthRoot: {},
    left: {
      flex: "1 1 auto"
    },
    fullWidthLeft: {
      flex: "1 1 auto"
    },
    actions: {
      flex: "1 1 auto",
      textAlign: "right"
    },
    fullWidthActions: {
      flex: "1 1 auto",
      textAlign: "right"
    },
    titleRoot: {},
    titleText: {},
    fullWidthTitleText: {
      textAlign: "left"
    },
    icon: {
      "&:hover": {
        color: e.palette.primary.main
      }
    },
    iconActive: {
      color: e.palette.primary.main
    },
    filterPaper: {
      maxWidth: "50%"
    },
    filterCloseIcon: {
      position: "absolute",
      right: 0,
      top: 0,
      zIndex: 100
    },
    searchIcon: {
      display: "inline-flex",
      marginTop: "10px",
      marginRight: "8px"
    }
  };
  return _defineProperty(t, e.breakpoints.down("sm"), {
    titleRoot: {},
    titleText: {
      fontSize: "16px"
    },
    spacer: {
      display: "none"
    },
    left: {
      padding: "8px 0px"
    },
    actions: {
      textAlign: "right"
    }
  }), _defineProperty(t, e.breakpoints.down("xs"), {
    root: {
      display: "block",
      "@media print": {
        display: "none !important"
      }
    },
    left: {
      padding: "8px 0px 0px 0px"
    },
    titleText: {
      textAlign: "center"
    },
    actions: {
      textAlign: "center"
    }
  }), _defineProperty(t, "@media screen and (max-width: 480px)", {}), t;
},
    RESPONSIVE_FULL_WIDTH_NAME = "scrollFullHeightFullWidth",
    TableToolbar = function (e) {
  _inherits(n, e);

  var r = _createSuper$4(n);

  function n() {
    var e, p;

    _classCallCheck(this, n);

    for (var t = arguments.length, o = new Array(t), a = 0; a < t; a++) o[a] = arguments[a];

    return p = r.call.apply(r, _concatInstanceProperty(e = [this]).call(e, o)), _defineProperty(_assertThisInitialized(p), "state", {
      iconActive: null,
      showSearch: Boolean(p.props.searchText || p.props.options.searchText || p.props.options.searchOpen),
      searchText: p.props.searchText || null
    }), _defineProperty(_assertThisInitialized(p), "handleCSVDownload", function () {
      var e,
          t = p.props,
          r = t.data,
          o = t.displayData,
          a = t.columns,
          n = t.options,
          s = t.columnOrder,
          l = [],
          i = [],
          c = _Array$isArray(s) ? _sliceInstanceProperty(s).call(s, 0) : [];
      0 === c.length && (c = _mapInstanceProperty(a).call(a, function (e, t) {
        return t;
      })), _forEachInstanceProperty(r).call(r, function (t) {
        var o = {
          index: t.index,
          data: []
        };
        _forEachInstanceProperty(c).call(c, function (e) {
          o.data.push(t.data[e]);
        }), l.push(o);
      }), _forEachInstanceProperty(c).call(c, function (e) {
        i.push(a[e]);
      }), n.downloadOptions && n.downloadOptions.filterOptions && (n.downloadOptions.filterOptions.useDisplayedRowsOnly && (e = _mapInstanceProperty(o).call(o, function (o, e) {
        var t,
            a = -1;
        return o.index = e, {
          data: _mapInstanceProperty(t = o.data).call(t, function (e) {
            a += 1;
            var t = "object" !== _typeof(e) || null === e || _Array$isArray(e) ? e : find(r, function (e) {
              return e.index === o.dataIndex;
            }).data[a];
            return t = "function" == typeof t ? find(r, function (e) {
              return e.index === o.dataIndex;
            }).data[a] : t;
          })
        };
      }), l = [], _forEachInstanceProperty(e).call(e, function (t) {
        var o = {
          index: t.index,
          data: []
        };
        _forEachInstanceProperty(c).call(c, function (e) {
          o.data.push(t.data[e]);
        }), l.push(o);
      })), n.downloadOptions.filterOptions.useDisplayedColumnsOnly && (i = _filterInstanceProperty(i).call(i, function (e) {
        return "true" === e.display;
      }), l = _mapInstanceProperty(l).call(l, function (e) {
        var t;
        return e.data = _filterInstanceProperty(t = e.data).call(t, function (e, t) {
          return "true" === a[c[t]].display;
        }), e;
      }))), createCSVDownload(i, l, n, downloadCSV);
    }), _defineProperty(_assertThisInitialized(p), "setActiveIcon", function (t) {
      p.setState(function (e) {
        return {
          showSearch: p.isSearchShown(t),
          iconActive: t,
          prevIconActive: e.iconActive
        };
      }, function () {
        var e = p.state,
            t = e.iconActive,
            o = e.prevIconActive;
        "filter" === t && (p.props.setTableAction("onFilterDialogOpen"), p.props.options.onFilterDialogOpen && p.props.options.onFilterDialogOpen()), void 0 === t && "filter" === o && (p.props.setTableAction("onFilterDialogClose"), p.props.options.onFilterDialogClose && p.props.options.onFilterDialogClose());
      });
    }), _defineProperty(_assertThisInitialized(p), "isSearchShown", function (e) {
      var t,
          o = !1;
      return p.state.showSearch ? o = !!p.state.searchText || (t = p.props.options.onSearchClose, p.props.setTableAction("onSearchClose"), t && t(), !1) : "search" === e && (o = p.showSearch()), o;
    }), _defineProperty(_assertThisInitialized(p), "getActiveIcon", function (e, t) {
      var o,
          a,
          r,
          n = p.state.iconActive === t;
      return "search" === t && (a = (o = p.state).showSearch, r = o.searchText, n = n || a || r), n ? e.iconActive : e.icon;
    }), _defineProperty(_assertThisInitialized(p), "showSearch", function () {
      return p.props.setTableAction("onSearchOpen"), p.props.options.onSearchOpen && p.props.options.onSearchOpen(), !0;
    }), _defineProperty(_assertThisInitialized(p), "hideSearch", function () {
      var e = p.props.options.onSearchClose;
      p.props.setTableAction("onSearchClose"), e && e(), p.props.searchClose(), p.setState(function () {
        return {
          iconActive: null,
          showSearch: !1,
          searchText: null
        };
      });
    }), _defineProperty(_assertThisInitialized(p), "handleSearch", function (e) {
      p.setState({
        searchText: e
      }), p.props.searchTextUpdate(e);
    }), _defineProperty(_assertThisInitialized(p), "handleSearchIconClick", function () {
      var e = p.state,
          t = e.showSearch,
          o = e.searchText;
      t && !o ? p.hideSearch() : p.setActiveIcon("search");
    }), p;
  }

  return _createClass(n, [{
    key: "componentDidUpdate",
    value: function value(e) {
      this.props.searchText !== e.searchText && this.setState({
        searchText: this.props.searchText
      });
    }
  }, {
    key: "render",
    value: function value() {
      var e,
          t,
          o,
          a = this,
          r = this.props,
          n = r.data,
          s = r.options,
          l = r.classes,
          i = r.columns,
          c = r.filterData,
          p = r.filterList,
          d = r.filterUpdate,
          u = r.resetFilters,
          f = r.toggleViewColumn,
          y = r.updateColumns,
          b = r.title,
          h = r.components,
          m = void 0 === h ? {} : h,
          _ = r.updateFilterByType,
          g = m.icons,
          P = void 0 === g ? {} : g,
          T = m.Tooltip || MuiTooltip,
          R = m.TableViewCol || TableViewCol,
          x = m.TableFilter || DefaultTableFilter,
          v = P.SearchIcon || SearchIcon,
          w = P.DownloadIcon || DownloadIcon,
          I = P.PrintIcon || PrintIcon,
          C = P.ViewColumnIcon || ViewColumnIcon,
          S = P.FilterIcon || FilterIcon,
          D = s.textLabels.toolbar,
          O = D.search,
          k = D.downloadCsv,
          E = D.print,
          L = D.viewColumns,
          F = D.filterTable,
          j = this.state,
          A = j.showSearch,
          $ = j.searchText;
      return React__default.createElement(Toolbar, {
        className: s.responsive !== RESPONSIVE_FULL_WIDTH_NAME ? l.root : l.fullWidthRoot,
        role: "toolbar",
        "aria-label": "Table Toolbar"
      }, React__default.createElement("div", {
        className: s.responsive !== RESPONSIVE_FULL_WIDTH_NAME ? l.left : l.fullWidthLeft
      }, !0 === A ? s.customSearchRender ? s.customSearchRender($, this.handleSearch, this.hideSearch, s) : React__default.createElement(TableSearch, {
        searchText: $,
        onSearch: this.handleSearch,
        onHide: this.hideSearch,
        options: s
      }) : "string" != typeof b ? b : React__default.createElement("div", {
        className: l.titleRoot,
        "aria-hidden": "true"
      }, React__default.createElement(Typography, {
        variant: "h6",
        className: s.responsive !== RESPONSIVE_FULL_WIDTH_NAME ? l.titleText : l.fullWidthTitleText
      }, b))), React__default.createElement("div", {
        className: s.responsive !== RESPONSIVE_FULL_WIDTH_NAME ? l.actions : l.fullWidthActions
      }, !(!1 === s.search || "false" === s.search) && React__default.createElement(T, {
        title: O,
        disableFocusListener: !0
      }, React__default.createElement(IconButton, {
        "aria-label": O,
        "data-testid": O + "-iconButton",
        buttonRef: function buttonRef(e) {
          return a.searchButton = e;
        },
        classes: {
          root: this.getActiveIcon(l, "search")
        },
        disabled: "disabled" === s.search,
        onClick: this.handleSearchIconClick
      }, React__default.createElement(v, null))), !(!1 === s.download || "false" === s.download) && React__default.createElement(T, {
        title: k
      }, React__default.createElement(IconButton, {
        "data-testid": k + "-iconButton",
        "aria-label": k,
        classes: {
          root: l.icon
        },
        disabled: "disabled" === s.download,
        onClick: this.handleCSVDownload
      }, React__default.createElement(w, null))), !(!1 === s.print || "false" === s.print) && React__default.createElement("span", null, React__default.createElement(ReactToPrint__default, {
        content: function content() {
          return a.props.tableRef();
        }
      }, React__default.createElement(ReactToPrint.PrintContextConsumer, null, function (e) {
        var t = e.handlePrint;
        return React__default.createElement("span", null, React__default.createElement(T, {
          title: E
        }, React__default.createElement(IconButton, {
          "data-testid": E + "-iconButton",
          "aria-label": E,
          disabled: "disabled" === s.print,
          onClick: t,
          classes: {
            root: l.icon
          }
        }, React__default.createElement(I, null))));
      }))), !(!1 === s.viewColumns || "false" === s.viewColumns) && React__default.createElement(Popover, {
        refExit: _bindInstanceProperty(e = this.setActiveIcon).call(e, null),
        classes: {
          closeIcon: l.filterCloseIcon
        },
        hide: "disabled" === s.viewColumns,
        trigger: React__default.createElement(T, {
          title: L,
          disableFocusListener: !0
        }, React__default.createElement(IconButton, {
          "data-testid": L + "-iconButton",
          "aria-label": L,
          classes: {
            root: this.getActiveIcon(l, "viewcolumns")
          },
          disabled: "disabled" === s.viewColumns,
          onClick: _bindInstanceProperty(t = this.setActiveIcon).call(t, null, "viewcolumns")
        }, React__default.createElement(C, null))),
        content: React__default.createElement(R, {
          data: n,
          columns: i,
          options: s,
          onColumnUpdate: f,
          updateColumns: y,
          components: m
        })
      }), !(!1 === _filterInstanceProperty(s) || "false" === _filterInstanceProperty(s)) && React__default.createElement(Popover, {
        refExit: function refExit() {
          a.setState({
            hideFilterPopover: !1
          }), a.setActiveIcon();
        },
        hide: this.state.hideFilterPopover || "disabled" === _filterInstanceProperty(s),
        classes: {
          paper: l.filterPaper,
          closeIcon: l.filterCloseIcon
        },
        trigger: React__default.createElement(T, {
          title: F,
          disableFocusListener: !0
        }, React__default.createElement(IconButton, {
          "data-testid": F + "-iconButton",
          "aria-label": F,
          classes: {
            root: this.getActiveIcon(l, "filter")
          },
          disabled: "disabled" === _filterInstanceProperty(s),
          onClick: _bindInstanceProperty(o = this.setActiveIcon).call(o, null, "filter")
        }, React__default.createElement(S, null))),
        content: React__default.createElement(x, {
          customFooter: s.customFilterDialogFooter,
          columns: i,
          options: s,
          filterList: p,
          filterData: c,
          onFilterUpdate: d,
          onFilterReset: u,
          handleClose: function handleClose() {
            a.setState({
              hideFilterPopover: !0
            });
          },
          updateFilterByType: _,
          components: m
        })
      }), s.customToolbar && s.customToolbar({
        displayData: this.props.displayData
      })));
    }
  }]), n;
}(React__default.Component),
    DefaultTableToolbar = styles.withStyles(defaultToolbarStyles, {
  name: "MUIDataTableToolbar"
})(TableToolbar);

function _createSuper$5(a) {
  var r = _isNativeReflectConstruct$5();

  return function () {
    var e,
        t,
        o = _getPrototypeOf(a);

    return t = r ? (e = _getPrototypeOf(this).constructor, _Reflect$construct(o, arguments, e)) : o.apply(this, arguments), _possibleConstructorReturn(this, t);
  };
}

function _isNativeReflectConstruct$5() {
  if ("undefined" == typeof Reflect || !_Reflect$construct) return !1;
  if (_Reflect$construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

var defaultToolbarSelectStyles = function defaultToolbarSelectStyles(e) {
  return {
    root: {
      backgroundColor: e.palette.background.default,
      flex: "1 1 100%",
      display: "flex",
      position: "relative",
      zIndex: 120,
      justifyContent: "space-between",
      alignItems: "center",
      paddingTop: "function" == typeof e.spacing ? e.spacing(1) : e.spacing.unit,
      paddingBottom: "function" == typeof e.spacing ? e.spacing(1) : e.spacing.unit,
      "@media print": {
        display: "none"
      }
    },
    title: {
      paddingLeft: "26px"
    },
    iconButton: {
      marginRight: "24px"
    },
    deleteIcon: {}
  };
},
    TableToolbarSelect = function (e) {
  _inherits(s, e);

  var n = _createSuper$5(s);

  function s() {
    var e, o;

    _classCallCheck(this, s);

    for (var t = arguments.length, a = new Array(t), r = 0; r < t; r++) a[r] = arguments[r];

    return o = n.call.apply(n, _concatInstanceProperty(e = [this]).call(e, a)), _defineProperty(_assertThisInitialized(o), "handleCustomSelectedRows", function (e) {
      if (!_Array$isArray(e)) throw new TypeError('"selectedRows" must be an "array", but it\'s "'.concat(_typeof(e), '"'));
      if (_someInstanceProperty(e).call(e, function (e) {
        return "number" != typeof e;
      })) throw new TypeError('Array "selectedRows" must contain only numbers');
      var t = o.props.options;
      if (1 < e.length && "single" === t.selectableRows) throw new Error('Can not select more than one row when "selectableRows" is "single"');
      o.props.selectRowUpdate("custom", e);
    }), o;
  }

  return _createClass(s, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.classes,
          o = e.onRowsDelete,
          a = e.selectedRows,
          r = e.options,
          n = e.displayData,
          s = e.components,
          l = void 0 === s ? {} : s,
          i = r.textLabels.selectedRows,
          c = l.Tooltip || MuiTooltip;
      return React__default.createElement(Paper, {
        className: t.root
      }, React__default.createElement("div", null, React__default.createElement(Typography, {
        variant: "subtitle1",
        className: t.title
      }, a.data.length, " ", i.text)), r.customToolbarSelect ? r.customToolbarSelect(a, n, this.handleCustomSelectedRows) : React__default.createElement(c, {
        title: i.delete
      }, React__default.createElement(IconButton, {
        className: t.iconButton,
        onClick: o,
        "aria-label": i.deleteAria
      }, React__default.createElement(DeleteIcon, {
        className: t.deleteIcon
      }))));
    }
  }]), s;
}(React__default.Component);

_defineProperty(TableToolbarSelect, "propTypes", {
  options: PropTypes.object.isRequired,
  rowSelected: PropTypes.bool,
  onRowsDelete: PropTypes.func,
  classes: PropTypes.object
});

var DefaultTableToolbarSelect = styles.withStyles(defaultToolbarSelectStyles, {
  name: "MUIDataTableToolbarSelect"
})(TableToolbarSelect),
    getTextLabels = function getTextLabels() {
  return {
    body: {
      noMatch: "Sorry, no matching records found",
      toolTip: "Sort"
    },
    pagination: {
      next: "Next Page",
      previous: "Previous Page",
      rowsPerPage: "Rows per page:",
      displayRows: "of",
      jumpToPage: "Jump to Page:"
    },
    toolbar: {
      search: "Search",
      downloadCsv: "Download CSV",
      print: "Print",
      viewColumns: "View Columns",
      filterTable: "Filter Table"
    },
    filter: {
      all: "All",
      title: "FILTERS",
      reset: "RESET"
    },
    viewColumns: {
      title: "Show Columns",
      titleAria: "Show/Hide Table Columns"
    },
    selectedRows: {
      text: "row(s) selected",
      delete: "Delete",
      deleteAria: "Delete Selected Rows"
    }
  };
};

function ownKeys$3(t, e) {
  var o,
      a = _Object$keys(t);

  return _Object$getOwnPropertySymbols && (o = _Object$getOwnPropertySymbols(t), e && (o = _filterInstanceProperty(o).call(o, function (e) {
    return _Object$getOwnPropertyDescriptor(t, e).enumerable;
  })), a.push.apply(a, o)), a;
}

function _objectSpread$3(t) {
  for (var e = 1; e < arguments.length; e++) {
    var o,
        a,
        r = null != arguments[e] ? arguments[e] : {};
    e % 2 ? _forEachInstanceProperty(o = ownKeys$3(Object(r), !0)).call(o, function (e) {
      _defineProperty(t, e, r[e]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(t, _Object$getOwnPropertyDescriptors(r)) : _forEachInstanceProperty(a = ownKeys$3(Object(r))).call(a, function (e) {
      _Object$defineProperty(t, e, _Object$getOwnPropertyDescriptor(r, e));
    });
  }

  return t;
}

function _createSuper$6(a) {
  var r = _isNativeReflectConstruct$6();

  return function () {
    var e,
        t,
        o = _getPrototypeOf(a);

    return t = r ? (e = _getPrototypeOf(this).constructor, _Reflect$construct(o, arguments, e)) : o.apply(this, arguments), _possibleConstructorReturn(this, t);
  };
}

function _isNativeReflectConstruct$6() {
  if ("undefined" == typeof Reflect || !_Reflect$construct) return !1;
  if (_Reflect$construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

var defaultTableStyles = function defaultTableStyles(e) {
  return {
    root: {},
    paper: {},
    paperResponsiveScrollFullHeightFullWidth: {
      position: "absolute"
    },
    tableRoot: {
      outline: "none"
    },
    responsiveBase: {
      overflow: "auto",
      "@media print": {
        height: "auto !important"
      }
    },
    responsiveScroll: {
      overflow: "auto",
      height: "100%"
    },
    responsiveScrollMaxHeight: {
      overflow: "auto",
      height: "100%"
    },
    responsiveScrollFullHeight: {
      height: "100%"
    },
    responsiveStacked: _defineProperty({
      overflow: "auto"
    }, e.breakpoints.down("sm"), {
      overflow: "hidden"
    }),
    responsiveStackedFullWidth: {},
    caption: {
      position: "absolute",
      left: "-3000px"
    },
    liveAnnounce: {
      border: "0",
      clip: "rect(0 0 0 0)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: "0",
      position: "absolute",
      width: "1px"
    },
    "@global": {
      "@media print": {
        ".datatables-noprint": {
          display: "none"
        }
      }
    }
  };
},
    TABLE_LOAD = {
  INITIAL: 1,
  UPDATE: 2
},
    TOOLBAR_ITEMS = ["title", "filter", "search", "print", "download", "viewColumns", "customToolbar"],
    hasToolbarItem = function hasToolbarItem(t, e) {
  return t.title = e, !isUndefined(find(TOOLBAR_ITEMS, function (e) {
    return t[e];
  }));
},
    STP = {
  REPLACE: "replace",
  ABOVE: "above",
  NONE: "none"
},
    MUIDataTable = function (e) {
  _inherits(a, e);

  var o = _createSuper$6(a);

  function a(e) {
    var t, y;
    _classCallCheck(this, a), y = o.call(this, e), _defineProperty(_assertThisInitialized(y), "getDefaultOptions", function () {
      return {
        caseSensitive: !1,
        consoleWarnings: !0,
        disableToolbarSelect: !1,
        download: !0,
        downloadOptions: {
          filename: "tableDownload.csv",
          separator: ","
        },
        draggableColumns: {
          enabled: !1,
          transitionTime: 300
        },
        elevation: 4,
        enableNestedDataAccess: "",
        expandableRows: !1,
        expandableRowsHeader: !0,
        expandableRowsOnClick: !1,
        filter: !0,
        filterArrayFullMatch: !0,
        filterType: "dropdown",
        fixedHeader: !0,
        fixedSelectColumn: !0,
        pagination: !0,
        print: !0,
        resizableColumns: !1,
        responsive: "vertical",
        rowHover: !0,
        rowsPerPageOptions: [10, 15, 100],
        search: !0,
        selectableRows: "multiple",
        selectableRowsHideCheckboxes: !1,
        selectableRowsOnClick: !1,
        selectableRowsHeader: !0,
        serverSide: !1,
        serverSideFilterList: null,
        setTableProps: function setTableProps() {
          return {};
        },
        sort: !0,
        sortFilterList: !0,
        tableBodyHeight: "auto",
        tableBodyMaxHeight: null,
        sortOrder: {},
        textLabels: getTextLabels(),
        viewColumns: !0,
        selectToolbarPlacement: STP.REPLACE
      };
    }), _defineProperty(_assertThisInitialized(y), "warnDep", function (e, t) {
      warnDeprecated(e, y.options.consoleWarnings);
    }), _defineProperty(_assertThisInitialized(y), "warnInfo", function (e, t) {
      warnInfo(e, y.options.consoleWarnings);
    }), _defineProperty(_assertThisInitialized(y), "handleOptionDeprecation", function (e) {
      var t, o, a, r;
      "boolean" == typeof y.options.selectableRows && (y.warnDep("Using a boolean for selectableRows has been deprecated. Please use string option: multiple | single | none"), y.options.selectableRows = y.options.selectableRows ? "multiple" : "none"), -1 === _indexOfInstanceProperty(t = ["standard", "vertical", "verticalAlways", "simple"]).call(t, y.options.responsive) && (-1 !== _indexOfInstanceProperty(a = ["scrollMaxHeight", "scrollFullHeight", "stacked", "stackedFullWidth", "scrollFullHeightFullWidth", "scroll"]).call(a, y.options.responsive) ? y.warnDep(y.options.responsive + " has been deprecated, but will still work in version 3.x. Please use string option: standard | vertical | simple. More info: https://github.com/gregnb/mui-datatables/tree/master/docs/v2_to_v3_guide.md") : y.warnInfo(y.options.responsive + " is not recognized as a valid input for responsive option. Please use string option: standard | vertical | simple. More info: https://github.com/gregnb/mui-datatables/tree/master/docs/v2_to_v3_guide.md")), y.options.onRowsSelect && y.warnDep("onRowsSelect has been renamed onRowSelectionChange. More info: https://github.com/gregnb/mui-datatables/tree/master/docs/v2_to_v3_guide.md"), y.options.onRowsExpand && y.warnDep("onRowsExpand has been renamed onRowExpansionChange. More info: https://github.com/gregnb/mui-datatables/tree/master/docs/v2_to_v3_guide.md"), y.options.fixedHeaderOptions && (void 0 !== y.options.fixedHeaderOptions.yAxis && void 0 === y.options.fixedHeader && (y.options.fixedHeader = y.options.fixedHeaderOptions.yAxis), void 0 !== y.options.fixedHeaderOptions.xAxis && void 0 === y.options.fixedSelectColumn && (y.options.fixedSelectColumn = y.options.fixedHeaderOptions.xAxis), y.warnDep("fixedHeaderOptions will still work but has been deprecated in favor of fixedHeader and fixedSelectColumn. More info: https://github.com/gregnb/mui-datatables/tree/master/docs/v2_to_v3_guide.md")), y.options.serverSideFilterList && y.warnDep("serverSideFilterList will still work but has been deprecated in favor of the confirmFilters option. See this example for details: https://github.com/gregnb/mui-datatables/blob/master/examples/serverside-filters/index.js More info here: https://github.com/gregnb/mui-datatables/tree/master/docs/v2_to_v3_guide.md"), _mapInstanceProperty(o = e.columns).call(o, function (e) {
        e.options && e.options.customFilterListRender && y.warnDep("The customFilterListRender option has been deprecated. It is being replaced by customFilterListOptions.render (Specify customFilterListOptions: { render: Function } in column options.)");
      }), !0 === y.options.disableToolbarSelect && y.warnDep('disableToolbarSelect has been deprecated but will still work in version 3.x. It is being replaced by "selectToolbarPlacement"="none". More info: https://github.com/gregnb/mui-datatables/tree/master/docs/v2_to_v3_guide.md'), _Object$values && -1 === _indexOfInstanceProperty(r = _Object$values(STP)).call(r, y.options.selectToolbarPlacement) && y.warnDep("Invalid option value for selectToolbarPlacement. Please check the documentation: https://github.com/gregnb/mui-datatables#options");
    }), _defineProperty(_assertThisInitialized(y), "setTableAction", function (e) {
      "function" == typeof y.options.onTableChange && y.options.onTableChange(e, y.state);
    }), _defineProperty(_assertThisInitialized(y), "setTableInit", function (e) {
      "function" == typeof y.options.onTableInit && y.options.onTableInit(e, y.state);
    }), _defineProperty(_assertThisInitialized(y), "setHeadCellRef", function (e, t, o) {
      y.draggableHeadCellRefs[e] = o, y.resizeHeadCellRefs[t] = o;
    }), _defineProperty(_assertThisInitialized(y), "getTableContentRef", function () {
      return y.tableContent.current;
    }), _defineProperty(_assertThisInitialized(y), "buildColumns", function (e) {
      var r = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : [],
          t = 2 < arguments.length ? arguments[2] : void 0,
          o = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : [],
          n = [],
          s = [],
          l = [],
          i = [];
      return _forEachInstanceProperty(e).call(e, function (e, t) {
        var o = {
          display: "true",
          empty: !1,
          filter: !0,
          sort: !0,
          print: !0,
          searchable: !0,
          download: !0,
          viewColumns: !0,
          sortCompare: null,
          sortThirdClickReset: !1,
          sortDescFirst: !1
        };
        i.push(t);

        var a = _objectSpread$3({}, e.options),
            o = "object" === _typeof(e) ? (a && (void 0 !== a.display && (a.display = a.display.toString()), null !== a.sortDirection && !a.sortDirection || y.warnDep("The sortDirection column field has been deprecated. Please use the sortOrder option on the options object. More info: https://github.com/gregnb/mui-datatables/tree/master/docs/v2_to_v3_guide.md")), void 0 === a.display && r[t] && r[t].name === e.name && r[t].display && (a.display = r[t].display), _objectSpread$3(_objectSpread$3({
          name: e.name,
          label: e.label ? e.label : e.name
        }, o), a)) : (r[t] && r[t].display && (a.display = r[t].display), _objectSpread$3(_objectSpread$3(_objectSpread$3({}, o), a), {}, {
          name: e,
          label: e
        }));

        n.push(o), s[t] = [], l[t] = [];
      }), _Array$isArray(t) ? i = t : _Array$isArray(o) && _Array$isArray(e) && _Array$isArray(r) && e.length === r.length && (i = o), {
        columns: n,
        filterData: s,
        filterList: l,
        columnOrder: i
      };
    }), _defineProperty(_assertThisInitialized(y), "transformData", function (e, t) {
      var n = y.options.enableNestedDataAccess;
      return _Array$isArray(t[0]) ? _mapInstanceProperty(t).call(t, function (t) {
        var o = -1;
        return _mapInstanceProperty(e).call(e, function (e) {
          return e.empty || o++, e.empty ? void 0 : t[o];
        });
      }) : _mapInstanceProperty(t).call(t, function (r) {
        return _mapInstanceProperty(e).call(e, function (e) {
          return t = r, o = e.name, _reduceInstanceProperty(a = n ? o.split(n) : o.split()).call(a, function (e, t) {
            return e ? e[t] : void 0;
          }, t);
          var t, o, a;
        });
      });
    }), _defineProperty(_assertThisInitialized(y), "hasSearchText", function (e, t, o) {
      var a = e.toString(),
          r = t.toString();
      return o || (r = r.toLowerCase(), a = a.toLowerCase()), 0 <= _indexOfInstanceProperty(a).call(a, r);
    }), _defineProperty(_assertThisInitialized(y), "updateDataCol", function (d, u, f) {
      y.setState(function (e) {
        var t,
            o,
            a,
            r,
            n = cloneDeep(e.data),
            s = cloneDeep(e.filterData),
            l = y.getTableMeta(d, u, d, e.columns[u], e.data, e, e.data),
            i = e.columns[u].customBodyRender(f, l),
            c = React__default.isValidElement(i) && i.props.value ? i.props.value : e.data[d][u],
            p = _indexOfInstanceProperty(t = s[u]).call(t, c);

        return _spliceInstanceProperty(o = s[u]).call(o, p, 1, c), n[d].data[u] = f, y.options.sortFilterList && (r = getCollatorComparator(), _sortInstanceProperty(a = s[u]).call(a, r)), {
          data: n,
          filterData: s,
          displayData: y.getDisplayData(e.columns, n, e.filterList, e.searchText, null, y.props)
        };
      });
    }), _defineProperty(_assertThisInitialized(y), "getTableMeta", function (e, t, o, a, r, n, s) {
      n.columns, n.data, n.displayData, n.filterData;
      return {
        rowIndex: e,
        columnIndex: t,
        columnData: a,
        rowData: o,
        tableData: r,
        tableState: _objectWithoutProperties(n, ["columns", "data", "displayData", "filterData"]),
        currentTableData: s
      };
    }), _defineProperty(_assertThisInitialized(y), "toggleViewColumn", function (o) {
      y.setState(function (e) {
        var t = cloneDeep(e.columns);
        return t[o].display = "true" === t[o].display ? "false" : "true", {
          columns: t
        };
      }, function () {
        y.setTableAction("viewColumnsChange");
        var e = y.options.onViewColumnsChange || y.options.onColumnViewChange;
        e && e(y.state.columns[o].name, "true" === y.state.columns[o].display ? "add" : "remove");
      });
    }), _defineProperty(_assertThisInitialized(y), "updateColumns", function (t) {
      y.setState(function (e) {
        return {
          columns: t
        };
      }, function () {
        y.setTableAction("viewColumnsChange");
        var e = y.options.onViewColumnsChange || y.options.onColumnViewChange;
        e && e(null, "update", t);
      });
    }), _defineProperty(_assertThisInitialized(y), "toggleSortColumn", function (d) {
      y.setState(function (e) {
        var t,
            o,
            a = cloneDeep(e.columns),
            r = e.data,
            n = a[d].sortDescFirst ? "desc" : "asc",
            s = ["asc", "desc"];
        a[d].sortDescFirst && (s = ["desc", "asc"]), a[d].sortThirdClickReset && s.push("none"), a[d].name !== y.state.sortOrder.name || -1 !== (o = _indexOfInstanceProperty(s).call(s, y.state.sortOrder.direction)) && (++o >= s.length && (o = 0), n = s[o]);
        var l,
            i = {
          name: a[d].name,
          direction: n
        },
            c = y.getSortDirectionLabel(i),
            p = {
          columns: a,
          announceText: _concatInstanceProperty(t = "Table now sorted by ".concat(a[d].name, " : ")).call(t, c),
          activeColumn: d
        };
        return p = y.options.serverSide ? _objectSpread$3(_objectSpread$3({}, p), {}, {
          data: e.data,
          displayData: e.displayData,
          selectedRows: e.selectedRows,
          sortOrder: i
        }) : (l = y.sortTable(r, d, n, a[d].sortCompare), _objectSpread$3(_objectSpread$3({}, p), {}, {
          data: l.data,
          displayData: y.getDisplayData(a, l.data, e.filterList, e.searchText, null, y.props),
          selectedRows: l.selectedRows,
          sortOrder: i,
          previousSelectedRow: null
        }));
      }, function () {
        y.setTableAction("sort"), y.options.onColumnSortChange && y.options.onColumnSortChange(y.state.sortOrder.name, y.state.sortOrder.direction);
      });
    }), _defineProperty(_assertThisInitialized(y), "changeRowsPerPage", function (e) {
      var t = y.options.count || y.state.displayData.length;
      y.setState(function () {
        return {
          rowsPerPage: e,
          page: getPageValue(t, e, y.state.page)
        };
      }, function () {
        y.setTableAction("changeRowsPerPage"), y.options.onChangeRowsPerPage && y.options.onChangeRowsPerPage(y.state.rowsPerPage);
      });
    }), _defineProperty(_assertThisInitialized(y), "changePage", function (e) {
      y.setState(function () {
        return {
          page: e
        };
      }, function () {
        y.setTableAction("changePage"), y.options.onChangePage && y.options.onChangePage(y.state.page);
      });
    }), _defineProperty(_assertThisInitialized(y), "searchClose", function () {
      y.setState(function (e) {
        return {
          searchText: null,
          displayData: y.options.serverSide ? e.displayData : y.getDisplayData(e.columns, e.data, e.filterList, null, null, y.props)
        };
      }, function () {
        y.setTableAction("search"), y.options.onSearchChange && y.options.onSearchChange(y.state.searchText);
      });
    }), _defineProperty(_assertThisInitialized(y), "searchTextUpdate", function (t) {
      y.setState(function (e) {
        return {
          searchText: t && t.length ? t : null,
          page: 0,
          displayData: y.options.serverSide ? e.displayData : y.getDisplayData(e.columns, e.data, e.filterList, t, null, y.props)
        };
      }, function () {
        y.setTableAction("search"), y.options.onSearchChange && y.options.onSearchChange(y.state.searchText);
      });
    }), _defineProperty(_assertThisInitialized(y), "resetFilters", function () {
      y.setState(function (e) {
        var t,
            o = _mapInstanceProperty(t = e.columns).call(t, function () {
          return [];
        });

        return {
          filterList: o,
          displayData: y.options.serverSide ? e.displayData : y.getDisplayData(e.columns, e.data, o, e.searchText, null, y.props)
        };
      }, function () {
        y.setTableAction("resetFilters"), y.options.onFilterChange && y.options.onFilterChange(null, y.state.filterList, "reset", null);
      });
    }), _defineProperty(_assertThisInitialized(y), "updateFilterByType", function (e, t, o, a, r) {
      var n,
          s,
          l,
          i = _findIndexInstanceProperty(n = e[t]).call(n, function (e) {
        return isEqual(e, o);
      });

      switch (a) {
        case "checkbox":
          0 <= i ? _spliceInstanceProperty(s = e[t]).call(s, i, 1) : e[t].push(o);
          break;

        case "chip":
          0 <= i ? _spliceInstanceProperty(l = e[t]).call(l, i, 1) : e[t].push(o);
          break;

        case "multiselect":
          e[t] = "" === o ? [] : o;
          break;

        case "dropdown":
          e[t] = o;
          break;

        case "custom":
          r ? e = r(e, i, t) : e[t] = o;
          break;

        default:
          e[t] = 0 <= i || "" === o ? [] : [o];
      }
    }), _defineProperty(_assertThisInitialized(y), "filterUpdate", function (o, a, e, r, n, t) {
      y.setState(function (e) {
        var t = cloneDeep(e.filterList);
        return y.updateFilterByType(t, o, a, r, n), {
          page: 0,
          filterList: t,
          displayData: y.options.serverSide ? e.displayData : y.getDisplayData(e.columns, e.data, t, e.searchText, null, y.props),
          previousSelectedRow: null
        };
      }, function () {
        y.setTableAction("filterChange"), y.options.onFilterChange && y.options.onFilterChange(e, y.state.filterList, r, o, y.state.displayData), t && t(y.state.filterList);
      });
    }), _defineProperty(_assertThisInitialized(y), "toggleAllExpandableRows", function () {
      var e = _toConsumableArray(y.state.expandedRows.data),
          t = y.options.isRowExpandable,
          o = [];

      if (0 < e.length) for (var a = e.length - 1; 0 <= a; a--) {
        var r = e[a];
        (!t || t && t(r.dataIndex, y.state.expandedRows)) && o.push(_spliceInstanceProperty(e).call(e, a, 1));
      } else for (var n = 0; n < y.state.data.length; n++) {
        var s,
            l = y.state.data[n];
        (!t || t && t(l.dataIndex, y.state.expandedRows)) && !0 !== y.state.expandedRows.lookup[l.index] && (s = {
          index: n,
          dataIndex: l.index
        }, e.push(s), o.push(s));
      }
      y.setState({
        expandedRows: {
          lookup: buildMap(e),
          data: e
        }
      }, function () {
        var e;
        y.setTableAction("expandRow"), y.options.onRowExpansionChange && y.options.onRowExpansionChange(o, y.state.expandedRows.data, _mapInstanceProperty(e = y.state.expandedRows.data).call(e, function (e) {
          return e.dataIndex;
        }));
      });
    }), _defineProperty(_assertThisInitialized(y), "areAllRowsExpanded", function () {
      return y.state.expandedRows.data.length === y.state.data.length;
    }), _defineProperty(_assertThisInitialized(y), "updateColumnOrder", function (t, e, o) {
      y.setState(function (e) {
        return {
          columnOrder: t
        };
      }, function () {
        y.setTableAction("columnOrderChange"), y.options.onColumnOrderChange && y.options.onColumnOrderChange(y.state.columnOrder, e, o);
      });
    }), _defineProperty(_assertThisInitialized(y), "selectRowDelete", function () {
      var e = y.state,
          t = e.selectedRows,
          o = e.data,
          a = e.filterList,
          r = buildMap(t.data),
          n = _filterInstanceProperty(o).call(o, function (e) {
        var t = e.index;
        return !r[t];
      });

      y.options.onRowsDelete && !1 === y.options.onRowsDelete(t, _mapInstanceProperty(n).call(n, function (e) {
        return e.data;
      })) || y.setTableData({
        columns: y.props.columns,
        data: n,
        options: {
          filterList: a
        }
      }, TABLE_LOAD.UPDATE, !0, function () {
        y.setTableAction("rowDelete");
      });
    }), _defineProperty(_assertThisInitialized(y), "toggleExpandRow", function (e) {
      for (var t = e.dataIndex, o = y.options.isRowExpandable, a = y.state.expandedRows, r = _toConsumableArray(a.data), n = !1, s = !1, l = [], i = 0; i < r.length; i++) if (r[i].dataIndex === t) {
        n = !0;
        break;
      }

      n ? (o && o(t, a) || !o) && (l = _spliceInstanceProperty(r).call(r, i, 1), s = !0) : (o && o(t, a) || !o) && r.push(e), y.setState({
        curExpandedRows: s ? l : [e],
        expandedRows: {
          lookup: buildMap(r),
          data: r
        }
      }, function () {
        y.setTableAction("rowExpansionChange"), (y.options.onRowExpansionChange || y.options.onRowsExpand) && (y.options.onRowExpansionChange || y.options.onRowsExpand)(y.state.curExpandedRows, y.state.expandedRows.data);
      });
    }), _defineProperty(_assertThisInitialized(y), "selectRowUpdate", function (e, i) {
      var p,
          t,
          o,
          a,
          c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : [],
          d = y.options.selectableRows;
      "none" !== d && ("head" === e ? (p = y.options.isRowSelectable, y.setState(function (e) {
        var t,
            a = e.displayData,
            r = e.selectedRows,
            o = e.selectedRows.data.length,
            n = o === a.length || o < a.length && 0 < o,
            s = _reduceInstanceProperty(a).call(a, function (e, t, o) {
          return (!p || p(a[o].dataIndex, r)) && e.push({
            index: o,
            dataIndex: a[o].dataIndex
          }), e;
        }, []),
            l = _toConsumableArray(s),
            i = buildMap(l);

        if (y.options.selectToolbarPlacement === STP.NONE) if (o > a.length) n = !0;else for (var c = 0; c < a.length; c++) i[a[c].dataIndex] || (n = !0);
        return n && (i = buildMap(l = _filterInstanceProperty(t = e.selectedRows.data).call(t, function (e) {
          var t = e.dataIndex;
          return !i[t];
        }))), {
          curSelectedRows: l,
          selectedRows: {
            data: l,
            lookup: i
          },
          previousSelectedRow: null
        };
      }, function () {
        var e, t;
        y.setTableAction("rowSelectionChange"), y.options.onRowSelectionChange ? y.options.onRowSelectionChange(y.state.curSelectedRows, y.state.selectedRows.data, _mapInstanceProperty(e = y.state.selectedRows.data).call(e, function (e) {
          return e.dataIndex;
        })) : y.options.onRowsSelect && y.options.onRowsSelect(y.state.curSelectedRows, y.state.selectedRows.data, _mapInstanceProperty(t = y.state.selectedRows.data).call(t, function (e) {
          return e.dataIndex;
        }));
      })) : "cell" === e ? y.setState(function (e) {
        for (var t, o = i.dataIndex, a = _toConsumableArray(e.selectedRows.data), r = -1, n = 0; n < a.length; n++) if (a[n].dataIndex === o) {
          r = n;
          break;
        }

        if (0 <= r) {
          if (_spliceInstanceProperty(a).call(a, r, 1), 0 < c.length) for (var s = buildMap(c), l = a.length - 1; 0 <= l; l--) s[a[l].dataIndex] && _spliceInstanceProperty(a).call(a, l, 1);
        } else "single" === d ? a = [i] : (a.push(i), 0 < c.length && (t = buildMap(a), _forEachInstanceProperty(c).call(c, function (e) {
          t[e.dataIndex] || a.push(e);
        })));

        return {
          selectedRows: {
            lookup: buildMap(a),
            data: a
          },
          previousSelectedRow: i
        };
      }, function () {
        var e, t;
        y.setTableAction("rowSelectionChange"), y.options.onRowSelectionChange ? y.options.onRowSelectionChange([i], y.state.selectedRows.data, _mapInstanceProperty(e = y.state.selectedRows.data).call(e, function (e) {
          return e.dataIndex;
        })) : y.options.onRowsSelect && y.options.onRowsSelect([i], y.state.selectedRows.data, _mapInstanceProperty(t = y.state.selectedRows.data).call(t, function (e) {
          return e.dataIndex;
        }));
      }) : "custom" === e && (t = y.state.displayData, a = buildMap(o = _mapInstanceProperty(i).call(i, function (e) {
        return {
          index: e,
          dataIndex: t[e].dataIndex
        };
      })), y.setState({
        selectedRows: {
          data: o,
          lookup: a
        },
        previousSelectedRow: null
      }, function () {
        var e, t;
        y.setTableAction("rowSelectionChange"), y.options.onRowSelectionChange ? y.options.onRowSelectionChange(y.state.selectedRows.data, y.state.selectedRows.data, _mapInstanceProperty(e = y.state.selectedRows.data).call(e, function (e) {
          return e.dataIndex;
        })) : y.options.onRowsSelect && y.options.onRowsSelect(y.state.selectedRows.data, y.state.selectedRows.data, _mapInstanceProperty(t = y.state.selectedRows.data).call(t, function (e) {
          return e.dataIndex;
        }));
      })));
    }), y.tableRef = React__default.createRef(), y.tableContent = React__default.createRef(), y.draggableHeadCellRefs = {}, y.resizeHeadCellRefs = {}, y.timers = {}, y.setHeadResizeable = function () {}, y.updateDividers = function () {};
    return y.mergeDefaultOptions(e), y.state = _Object$assign({
      activeColumn: null,
      announceText: null,
      count: 0,
      columns: [],
      expandedRows: {
        data: [],
        lookup: {}
      },
      data: [],
      displayData: [],
      filterData: [],
      filterList: [],
      page: 0,
      previousSelectedRow: null,
      rowsPerPage: 10,
      searchProps: {},
      searchText: null,
      selectedRows: {
        data: [],
        lookup: {}
      },
      showResponsive: !1,
      sortOrder: {}
    }, y.getInitTableOptions()), y.setTableData = _bindInstanceProperty(t = y.setTableData).call(t, _assertThisInitialized(y)), y.setTableData(e, TABLE_LOAD.INITIAL, !0, null, !0), y;
  }

  return _createClass(a, [{
    key: "componentDidMount",
    value: function value() {
      this.setHeadResizeable(this.resizeHeadCellRefs, this.tableRef), this.props.options.searchText && !this.props.options.serverSide && this.setState({
        page: 0
      }), this.setTableInit("tableInitialized");
    }
  }, {
    key: "componentDidUpdate",
    value: function value(e) {
      var t,
          o = this;
      this.props.data === e.data && this.props.columns === e.columns && this.props.options === e.options || (this.updateOptions(this.options, this.props), t = this.props.data !== e.data, this.props.data && e.data && (t = t && this.props.data.length === e.data.length), this.setTableData(this.props, TABLE_LOAD.INITIAL, t, function () {
        o.setTableAction("propsUpdate");
      })), this.props.options.searchText === e.options.searchText || this.props.options.serverSide || this.setState({
        page: 0
      }), (!0 === this.options.resizableColumns || this.options.resizableColumns && this.options.resizableColumns.enabled) && (this.setHeadResizeable(this.resizeHeadCellRefs, this.tableRef), this.updateDividers());
    }
  }, {
    key: "updateOptions",
    value: function value(e, t) {
      !0 === t.options.disableToolbarSelect && void 0 === t.options.selectToolbarPlacement && (t.options.selectToolbarPlacement = STP.NONE), t.options.draggableColumns && !0 === t.options.draggableColumns.enabled && !t.options.tableId && (t.options.tableId = (Math.random() + "").replace(/\./, "")), this.options = assignwith(e, t.options, function (e, t, o) {
        if ("textLabels" === o || "downloadOptions" === o) return merge(e, t);
      }), this.handleOptionDeprecation(t);
    }
  }, {
    key: "mergeDefaultOptions",
    value: function value(e) {
      var t = this.getDefaultOptions(),
          o = _Object$assign({}, e);

      o.options = o.options || {}, this.updateOptions(t, o);
    }
  }, {
    key: "validateOptions",
    value: function value(e) {
      var t;
      if (e.serverSide && void 0 === e.onTableChange) throw Error("onTableChange callback must be provided when using serverSide option");
      if (e.expandableRows && void 0 === e.renderExpandableRow) throw Error("renderExpandableRow must be provided when using expandableRows option");
      e.rowsSelected && _Array$isArray(e.rowsSelected) && _someInstanceProperty(t = e.rowsSelected).call(t, isNaN) && warnInfo("When using the rowsSelected option, must be provided an array of numbers only.");
    }
  }, {
    key: "getInitTableOptions",
    value: function value() {
      var o = this,
          e = ["rowsPerPage", "page", "rowsSelected", "rowsPerPageOptions"],
          t = _reduceInstanceProperty(e).call(e, function (e, t) {
        return void 0 !== o.options[t] && (e[t] = o.options[t]), e;
      }, {});

      return this.validateOptions(t), t;
    }
  }, {
    key: "setTableData",
    value: function value(e, c, t, o, a) {
      var p,
          r,
          d,
          u = this,
          n = 3 < arguments.length && void 0 !== o ? o : function () {},
          s = 4 < arguments.length && void 0 !== a && a,
          f = [],
          l = this.buildColumns(e.columns, this.state.columns, this.options.columnOrder, this.state.columnOrder),
          i = l.columns,
          y = l.filterData,
          b = l.filterList,
          h = l.columnOrder,
          m = null,
          _ = "none";
      this.options.sortOrder && this.options.sortOrder.direction && this.options.sortOrder.name ? d = _Object$assign({}, this.options.sortOrder) : (d = _Object$assign({}, this.state.sortOrder)).direction || _forEachInstanceProperty(r = e.columns).call(r, function (e, t) {
        !e.options || "asc" !== e.options.sortDirection && "desc" !== e.options.sortDirection || (d.name = e.name, d.sortDirection = e.sortDirection);
      });
      var g = c === TABLE_LOAD.INITIAL ? this.transformData(i, e.data) : e.data,
          P = c === TABLE_LOAD.INITIAL ? this.options.searchText : null;
      void 0 === this.options.searchText && void 0 !== this.state.searchText && (P = this.state.searchText);
      var T = this.state.rowsPerPage;
      "number" == typeof this.options.rowsPerPage && (T = this.options.rowsPerPage);
      var R = this.state.page;
      "number" == typeof this.options.page && (R = this.options.page), _forEachInstanceProperty(i).call(i, function (e, a) {
        for (var t, o, r = 0; r < g.length; r++) {
          var n,
              s,
              l,
              i = c === TABLE_LOAD.INITIAL ? g[r][a] : g[r].data[a];
          void 0 === f[r] && f.push({
            index: c === TABLE_LOAD.INITIAL ? r : g[r].index,
            data: c === TABLE_LOAD.INITIAL ? g[r] : g[r].data
          }), !1 !== _filterInstanceProperty(e) && ("function" == typeof e.customBodyRender && (s = f[r].data, p = u.getTableMeta(r, a, s, e, g, u.state, f), l = e.customBodyRender(i, p), React__default.isValidElement(l) && l.props.value ? i = l.props.value : "string" == typeof l && (i = l)), "object" !== _typeof(i) || _Array$isArray(i) || null === i || (i = i.toString ? i.toString() : ""), _indexOfInstanceProperty(n = y[a]).call(n, i) < 0 && !_Array$isArray(i) ? y[a].push(i) : _Array$isArray(i) && _forEachInstanceProperty(i).call(i, function (e) {
            var t,
                o = "object" === _typeof(e) && null !== e || "function" == typeof e ? e.toString ? e.toString() : "" : e;
            _indexOfInstanceProperty(t = y[a]).call(t, o) < 0 && y[a].push(o);
          }));
        }

        e.filterOptions && (_Array$isArray(e.filterOptions) ? (y[a] = cloneDeep(e.filterOptions), u.warnDep("filterOptions must now be an object. see https://github.com/gregnb/mui-datatables/tree/master/examples/customize-filter example")) : _Array$isArray(e.filterOptions.names) && (y[a] = cloneDeep(e.filterOptions.names))), e.filterList ? b[a] = cloneDeep(e.filterList) : u.state.filterList && u.state.filterList[a] && 0 < u.state.filterList[a].length && (b[a] = cloneDeep(u.state.filterList[a])), u.options.sortFilterList && (o = getCollatorComparator(), _sortInstanceProperty(t = y[a]).call(t, o)), e.name === d.name && (_ = d.direction, m = a);
      });
      var x,
          v,
          w,
          I = {
        data: [],
        lookup: {}
      },
          C = {
        data: [],
        lookup: {}
      };
      if (this.options.rowsSelected && this.options.rowsSelected.length && "multiple" === this.options.selectableRows) _forEachInstanceProperty(x = _filterInstanceProperty(v = this.options.rowsSelected).call(v, function (e) {
        return 0 === e || Number(e) && 0 < e;
      })).call(x, function (e) {
        for (var t = e, o = 0; o < u.state.displayData.length; o++) if (u.state.displayData[o].dataIndex === e) {
          t = o;
          break;
        }

        I.data.push({
          index: t,
          dataIndex: e
        }), I.lookup[e] = !0;
      });else if (this.options.rowsSelected && 1 === this.options.rowsSelected.length && "single" === this.options.selectableRows) {
        for (var S = this.options.rowsSelected[0], D = 0; D < this.state.displayData.length; D++) if (this.state.displayData[D].dataIndex === this.options.rowsSelected[0]) {
          S = D;
          break;
        }

        I.data.push({
          index: S,
          dataIndex: this.options.rowsSelected[0]
        }), I.lookup[this.options.rowsSelected[0]] = !0;
      } else this.options.rowsSelected && 1 < this.options.rowsSelected.length && "single" === this.options.selectableRows ? console.error('Multiple values provided for selectableRows, but selectableRows set to "single". Either supply only a single value or use "multiple".') : void 0 === this.options.rowsSelected && !1 === t && this.state.selectedRows && (I = _Object$assign({}, this.state.selectedRows));
      this.options.rowsExpanded && this.options.rowsExpanded.length && this.options.expandableRows ? _forEachInstanceProperty(w = this.options.rowsExpanded).call(w, function (e) {
        for (var t = e, o = 0; o < u.state.displayData.length; o++) if (u.state.displayData[o].dataIndex === e) {
          t = o;
          break;
        }

        C.data.push({
          index: t,
          dataIndex: e
        }), C.lookup[e] = !0;
      }) : void 0 === this.options.rowsExpanded && !1 === t && this.state.expandedRows && (C = _Object$assign({}, this.state.expandedRows)), this.options.serverSide || null === m || (f = this.sortTable(f, m, _, i[m].sortCompare).data);
      var O = {
        columns: i,
        filterData: y,
        filterList: b,
        searchText: P,
        selectedRows: I,
        expandedRows: C,
        count: this.options.count,
        data: f,
        sortOrder: d,
        rowsPerPage: T,
        page: R,
        displayData: this.getDisplayData(i, f, b, P, p, e),
        columnOrder: h
      };
      s ? this.state = _Object$assign({}, this.state, O) : this.setState(O, n);
    }
  }, {
    key: "computeDisplayRow",
    value: function value(d, u, f, y, b, h, m, e, _) {
      for (var g = this, P = !1, T = !1, R = [], t = 0; t < u.length; t++) !function (e) {
        var t,
            o,
            a,
            r = u[e],
            n = u[e],
            s = d[e];
        s.customBodyRenderLite ? R.push(s.customBodyRenderLite) : (s.customBodyRender && (o = g.getTableMeta(f, e, u, s, h, _objectSpread$3(_objectSpread$3({}, g.state), {}, {
          filterList: y,
          searchText: b
        }), _), a = s.customBodyRender(n, o, _bindInstanceProperty(t = g.updateDataCol).call(t, null, f, e)), n = "string" != typeof (r = a) && a ? a.props && a.props.value ? a.props.value : n : a), R.push(r));
        var l = null == n ? "" : n.toString(),
            i = y[e],
            c = m.caseSensitive,
            p = s.filterType || m.filterType;
        !i.length && "custom" !== p || (s.filterOptions && s.filterOptions.logic ? s.filterOptions.logic(n, i, u) && (P = !0) : "textField" === p && !g.hasSearchText(l, i, c) || "textField" !== p && !1 === _Array$isArray(n) && _indexOfInstanceProperty(i).call(i, n) < 0 ? P = !0 : "textField" !== p && _Array$isArray(n) && (m.filterArrayFullMatch ? _everyInstanceProperty(i).call(i, function (e) {
          return 0 <= _indexOfInstanceProperty(n).call(n, e);
        }) || (P = !0) : _someInstanceProperty(i).call(i, function (e) {
          return 0 <= _indexOfInstanceProperty(n).call(n, e);
        }) || (P = !0))), b && "excluded" !== s.display && g.hasSearchText(l, b, c) && "false" !== s.display && s.searchable && (T = !0);
      }(t);

      var o,
          a = e.options.customSearch;
      return b && a && ("boolean" != typeof (o = a(b, u, d)) ? console.error("customSearch must return a boolean") : T = o), m.serverSide ? (a && console.warn("Server-side filtering is enabled, hence custom search will be ignored."), R) : P || b && !T ? null : R;
    }
  }, {
    key: "getDisplayData",
    value: function value(e, t, o, a, r, n) {
      for (var s = [], l = r ? r.tableData : n.data, i = 0; i < t.length; i++) {
        var c = t[i].data,
            p = this.computeDisplayRow(e, c, i, o, a, l, this.options, n, t);
        p && s.push({
          data: p,
          dataIndex: t[i].index
        });
      }

      return s;
    }
  }, {
    key: "getSortDirectionLabel",
    value: function value(e) {
      switch (e.direction) {
        case "asc":
          return "ascending";

        case "desc":
          return "descending";

        case "none":
          return "none";

        default:
          return "";
      }
    }
  }, {
    key: "getTableProps",
    value: function value() {
      var e = this.props.classes,
          t = this.options.setTableProps() || {};
      return t.className = clsx(e.tableRoot, t.className), t;
    }
  }, {
    key: "sortTable",
    value: function value(e, o, t, a) {
      var r,
          n = this,
          s = 3 < arguments.length && void 0 !== a ? a : null,
          l = this.options.customSort && !s,
          i = {
        selectedRows: this.state.selectedRows
      },
          c = l ? this.options.customSort(e, o, t || (this.options.sortDescFirst ? "desc" : "asc"), i) : e;
      "none" === t && (r = _reduceInstanceProperty(e).call(e, function (e, t) {
        return e[t.index] = t, e;
      }, []));

      var p,
          d = _mapInstanceProperty(c).call(c, function (e, t) {
        return {
          data: e.data[o],
          rowData: e.data,
          position: t,
          rowSelected: !!n.state.selectedRows.lookup[e.index]
        };
      });

      l || (p = s || sortCompare, _sortInstanceProperty(d).call(d, p(t)));

      for (var u = [], f = [], y = 0; y < d.length; y++) {
        var b = d[y];
        u.push(c[b.position]), b.rowSelected && f.push({
          index: y,
          dataIndex: c[b.position].index
        });
      }

      return {
        data: "none" === t ? r : u,
        selectedRows: {
          lookup: buildMap(f),
          data: f
        }
      };
    }
  }, {
    key: "render",
    value: function value() {
      var e,
          t,
          o,
          a,
          r,
          n = this,
          s = this.props,
          l = s.classes,
          i = s.className,
          c = s.title,
          p = s.components,
          d = p.TableBody,
          u = p.TableFilterList,
          f = p.TableFooter,
          y = p.TableHead,
          b = p.TableResize,
          h = p.TableToolbar,
          m = p.TableToolbarSelect,
          _ = p.DragDropBackend,
          g = void 0 === _ ? reactDndHtml5Backend.HTML5Backend : _,
          P = this.state,
          T = P.announceText,
          R = P.activeColumn,
          x = P.data,
          v = P.displayData,
          w = P.columns,
          I = P.page,
          C = P.filterData,
          S = P.filterList,
          D = P.selectedRows,
          O = P.previousSelectedRow,
          k = P.expandedRows,
          E = P.searchText,
          L = P.sortOrder,
          F = (P.serverSideFilterList, P.columnOrder),
          j = d || DefaultTableBody,
          A = u || TableFilterList,
          $ = f || TableFooter,
          H = y || TableHead,
          z = b || DefaultTableResize,
          N = h || DefaultTableToolbar,
          B = m || DefaultTableToolbarSelect,
          q = this.state.count || v.length,
          M = this.options.pagination ? this.state.rowsPerPage : v.length,
          W = hasToolbarItem(this.options, c),
          U = _mapInstanceProperty(w).call(w, function (e) {
        return {
          name: e.name,
          filterType: e.filterType || n.options.filterType
        };
      }),
          V = this.options.responsive,
          K = _concatInstanceProperty(e = "".concat(l.paper, " ")).call(e, i),
          G = this.options.tableBodyMaxHeight;

      switch (V) {
        case "scroll":
          r = l.responsiveScroll, G = "499px";
          break;

        case "scrollMaxHeight":
          r = l.responsiveScrollMaxHeight, G = "499px";
          break;

        case "scrollFullHeight":
          r = l.responsiveScrollFullHeight, G = "none";
          break;

        case "scrollFullHeightFullWidth":
          r = l.responsiveScrollFullHeight, K = _concatInstanceProperty(t = "".concat(l.paperResponsiveScrollFullHeightFullWidth, " ")).call(t, i);
          break;

        case "stacked":
          r = l.responsiveStacked, G = "none";
          break;

        case "stackedFullWidth":
          r = l.responsiveStackedFullWidth, K = _concatInstanceProperty(o = "".concat(l.paperResponsiveScrollFullHeightFullWidth, " ")).call(o, i), G = "none";
          break;

        default:
          r = l.responsiveBase;
      }

      var X = {};
      G && (X.maxHeight = G), this.options.tableBodyHeight && (X.height = this.options.tableBodyHeight);
      var J = this.options.setTableProps && this.options.setTableProps() || {},
          Q = clsx(l.tableRoot, J.className);
      delete J.className;
      var Y,
          Z = {};
      return "undefined" != typeof window && (Z.context = window), React__default.createElement(core.Paper, {
        elevation: this.options.elevation,
        ref: this.tableContent,
        className: K
      }, 0 < D.data.length && this.options.selectToolbarPlacement !== STP.NONE && React__default.createElement(B, {
        options: this.options,
        selectedRows: D,
        onRowsDelete: this.selectRowDelete,
        displayData: v,
        selectRowUpdate: this.selectRowUpdate,
        components: this.props.components
      }), (0 === D.data.length || -1 !== _indexOfInstanceProperty(a = [STP.ABOVE, STP.NONE]).call(a, this.options.selectToolbarPlacement)) && W && React__default.createElement(N, {
        columns: w,
        columnOrder: F,
        displayData: v,
        data: x,
        filterData: C,
        filterList: S,
        filterUpdate: this.filterUpdate,
        updateFilterByType: this.updateFilterByType,
        options: this.options,
        resetFilters: this.resetFilters,
        searchText: E,
        searchTextUpdate: this.searchTextUpdate,
        searchClose: this.searchClose,
        tableRef: this.getTableContentRef,
        title: c,
        toggleViewColumn: this.toggleViewColumn,
        updateColumns: this.updateColumns,
        setTableAction: this.setTableAction,
        components: this.props.components
      }), React__default.createElement(A, {
        options: this.options,
        serverSideFilterList: this.props.options.serverSideFilterList,
        filterListRenderers: _mapInstanceProperty(w).call(w, function (e) {
          return e.customFilterListOptions && e.customFilterListOptions.render ? e.customFilterListOptions.render : e.customFilterListRender ? e.customFilterListRender : function (e) {
            return e;
          };
        }),
        customFilterListUpdate: _mapInstanceProperty(w).call(w, function (e) {
          return e.customFilterListOptions && e.customFilterListOptions.update ? e.customFilterListOptions.update : null;
        }),
        filterList: S,
        filterUpdate: this.filterUpdate,
        columnNames: U
      }), React__default.createElement("div", {
        style: _objectSpread$3({
          position: "relative"
        }, X),
        className: r
      }, (!0 === this.options.resizableColumns || this.options.resizableColumns && this.options.resizableColumns.enabled) && React__default.createElement(z, {
        key: q,
        columnOrder: F,
        updateDividers: function updateDividers(e) {
          return n.updateDividers = e;
        },
        setResizeable: function setResizeable(e) {
          return n.setHeadResizeable = e;
        },
        options: this.props.options,
        tableId: this.options.tableId
      }), (Y = React__default.createElement(core.Table, _extends({
        ref: function ref(e) {
          return n.tableRef = e;
        },
        tabIndex: "0",
        role: "grid",
        className: Q
      }, J), React__default.createElement("caption", {
        className: l.caption
      }, c), React__default.createElement(H, {
        columns: w,
        activeColumn: R,
        data: v,
        count: q,
        page: I,
        rowsPerPage: M,
        selectedRows: D,
        selectRowUpdate: n.selectRowUpdate,
        toggleSort: n.toggleSortColumn,
        setCellRef: n.setHeadCellRef,
        expandedRows: k,
        areAllRowsExpanded: n.areAllRowsExpanded,
        toggleAllExpandableRows: n.toggleAllExpandableRows,
        options: n.options,
        sortOrder: L,
        columnOrder: F,
        updateColumnOrder: n.updateColumnOrder,
        draggableHeadCellRefs: n.draggableHeadCellRefs,
        tableRef: n.getTableContentRef,
        tableId: n.options.tableId,
        timers: n.timers,
        components: n.props.components
      }), React__default.createElement(j, {
        data: v,
        count: q,
        columns: w,
        page: I,
        rowsPerPage: M,
        selectedRows: D,
        selectRowUpdate: n.selectRowUpdate,
        previousSelectedRow: O,
        expandedRows: k,
        toggleExpandRow: n.toggleExpandRow,
        options: n.options,
        columnOrder: F,
        filterList: S,
        components: n.props.components,
        tableId: n.options.tableId
      }), n.options.customTableBodyFooterRender ? n.options.customTableBodyFooterRender({
        data: v,
        count: q,
        columns: w,
        selectedRows: D,
        selectableRows: n.options.selectableRows
      }) : null), g ? React__default.createElement(reactDnd.DndProvider, _extends({
        backend: g
      }, Z), Y) : Y)), React__default.createElement($, {
        options: this.options,
        page: I,
        rowCount: q,
        rowsPerPage: M,
        changeRowsPerPage: this.changeRowsPerPage,
        changePage: this.changePage
      }), React__default.createElement("div", {
        className: l.liveAnnounce,
        "aria-live": "polite"
      }, T));
    }
  }]), a;
}(React__default.Component);

_defineProperty(MUIDataTable, "propTypes", {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  data: PropTypes.array.isRequired,
  columns: PropTypes.PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    options: PropTypes.shape({
      display: PropTypes.oneOf(["true", "false", "excluded", "always", !0, !1]),
      empty: PropTypes.bool,
      filter: PropTypes.bool,
      sort: PropTypes.bool,
      print: PropTypes.bool,
      searchable: PropTypes.bool,
      download: PropTypes.bool,
      viewColumns: PropTypes.bool,
      filterList: PropTypes.array,
      filterOptions: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({
        names: PropTypes.array,
        logic: PropTypes.func,
        display: PropTypes.func
      })]),
      filterType: PropTypes.oneOf(["dropdown", "checkbox", "multiselect", "textField", "custom"]),
      customHeadRender: PropTypes.func,
      customBodyRender: PropTypes.func,
      customBodyRenderLite: PropTypes.func,
      customHeadLabelRender: PropTypes.func,
      customFilterListOptions: PropTypes.oneOfType([PropTypes.shape({
        render: PropTypes.func,
        update: PropTypes.func
      })]),
      customFilterListRender: PropTypes.func,
      setCellProps: PropTypes.func,
      setCellHeaderProps: PropTypes.func,
      sortThirdClickReset: PropTypes.bool,
      sortDescFirst: PropTypes.bool
    })
  })])).isRequired,
  options: PropTypes.shape({
    caseSensitive: PropTypes.bool,
    columnOrder: PropTypes.array,
    count: PropTypes.number,
    confirmFilters: PropTypes.bool,
    consoleWarnings: PropTypes.bool,
    customFilterDialogFooter: PropTypes.func,
    customFooter: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
    customRowRender: PropTypes.func,
    customSearch: PropTypes.func,
    customSearchRender: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
    customSort: PropTypes.func,
    customToolbar: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
    customToolbarSelect: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
    draggableColumns: PropTypes.object,
    enableNestedDataAccess: PropTypes.string,
    expandableRows: PropTypes.bool,
    expandableRowsHeader: PropTypes.bool,
    expandableRowsOnClick: PropTypes.bool,
    disableToolbarSelect: PropTypes.bool,
    download: PropTypes.oneOf([!0, !1, "true", "false", "disabled"]),
    downloadOptions: PropTypes.shape({
      filename: PropTypes.string,
      separator: PropTypes.string,
      filterOptions: PropTypes.shape({
        useDisplayedColumnsOnly: PropTypes.bool,
        useDisplayedRowsOnly: PropTypes.bool
      })
    }),
    filter: PropTypes.oneOf([!0, !1, "true", "false", "disabled"]),
    filterArrayFullMatch: PropTypes.bool,
    filterType: PropTypes.oneOf(["dropdown", "checkbox", "multiselect", "textField", "custom"]),
    fixedHeader: PropTypes.bool,
    fixedSelectColumn: PropTypes.bool,
    getTextLabels: PropTypes.func,
    isRowExpandable: PropTypes.func,
    isRowSelectable: PropTypes.func,
    jumpToPage: PropTypes.bool,
    onDownload: PropTypes.func,
    onFilterChange: PropTypes.func,
    onFilterChipClose: PropTypes.func,
    onFilterConfirm: PropTypes.func,
    onFilterDialogOpen: PropTypes.func,
    onFilterDialogClose: PropTypes.func,
    onRowClick: PropTypes.func,
    onRowsExpand: PropTypes.func,
    onRowExpansionChange: PropTypes.func,
    onRowsSelect: PropTypes.func,
    onRowSelectionChange: PropTypes.func,
    onTableChange: PropTypes.func,
    onTableInit: PropTypes.func,
    page: PropTypes.number,
    pagination: PropTypes.bool,
    print: PropTypes.oneOf([!0, !1, "true", "false", "disabled"]),
    searchProps: PropTypes.object,
    selectableRows: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(["none", "single", "multiple"])]),
    selectableRowsHeader: PropTypes.bool,
    selectableRowsHideCheckboxes: PropTypes.bool,
    selectableRowsOnClick: PropTypes.bool,
    serverSide: PropTypes.bool,
    tableId: PropTypes.string,
    tableBodyHeight: PropTypes.string,
    tableBodyMaxHeight: PropTypes.string,
    renderExpandableRow: PropTypes.func,
    resizableColumns: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    responsive: PropTypes.oneOf(["standard", "vertical", "verticalAlways", "simple"]),
    rowHover: PropTypes.bool,
    rowsExpanded: PropTypes.array,
    rowsPerPage: PropTypes.number,
    rowsPerPageOptions: PropTypes.array,
    rowsSelected: PropTypes.array,
    search: PropTypes.oneOf([!0, !1, "true", "false", "disabled"]),
    searchOpen: PropTypes.bool,
    searchPlaceholder: PropTypes.string,
    searchText: PropTypes.string,
    setFilterChipProps: PropTypes.func,
    setRowProps: PropTypes.func,
    selectToolbarPlacement: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf([STP.REPLACE, STP.ABOVE, STP.NONE])]),
    setTableProps: PropTypes.func,
    sort: PropTypes.bool,
    sortOrder: PropTypes.object,
    viewColumns: PropTypes.oneOf([!0, !1, "true", "false", "disabled"])
  }),
  className: PropTypes.string,
  components: PropTypes.objectOf(PropTypes.any)
}), _defineProperty(MUIDataTable, "defaultProps", {
  title: "",
  options: {},
  data: [],
  columns: [],
  components: {
    TableBody: DefaultTableBody,
    TableFilter: DefaultTableFilter,
    TableFilterList: TableFilterList,
    TableFooter: TableFooter,
    TableHead: TableHead,
    TableResize: DefaultTableResize,
    TableToolbar: DefaultTableToolbar,
    TableToolbarSelect: DefaultTableToolbarSelect,
    Tooltip: core.Tooltip,
    icons: {}
  }
});
var MUIDataTable$1 = styles.withStyles(defaultTableStyles, {
  name: "MUIDataTable"
})(MUIDataTable);

function _createSuper$7(a) {
  var r = _isNativeReflectConstruct$7();

  return function () {
    var e,
        t,
        o = _getPrototypeOf(a);

    return t = r ? (e = _getPrototypeOf(this).constructor, _Reflect$construct(o, arguments, e)) : o.apply(this, arguments), _possibleConstructorReturn(this, t);
  };
}

function _isNativeReflectConstruct$7() {
  if ("undefined" == typeof Reflect || !_Reflect$construct) return !1;
  if (_Reflect$construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

function debounce(a, r, n) {
  var s;
  return function () {
    var e = this,
        t = arguments,
        o = n && !s;
    clearTimeout(s), s = _setTimeout(function () {
      s = null, n || a.apply(e, t);
    }, r), o && a.apply(e, t);
  };
}

var defaultStyles = function defaultStyles(e) {
  return {
    main: {
      display: "flex",
      flex: "1 0 auto"
    },
    searchIcon: {
      color: e.palette.text.secondary,
      marginTop: "10px",
      marginRight: "8px"
    },
    searchText: {
      flex: "0.8 0"
    },
    clearIcon: {
      "&:hover": {
        color: e.palette.error.main
      }
    }
  };
},
    _DebounceTableSearch = function (e) {
  _inherits(s, e);

  var n = _createSuper$7(s);

  function s() {
    var e, t;

    _classCallCheck(this, s);

    for (var o = arguments.length, a = new Array(o), r = 0; r < o; r++) a[r] = arguments[r];

    return t = n.call.apply(n, _concatInstanceProperty(e = [this]).call(e, a)), _defineProperty(_assertThisInitialized(t), "handleTextChangeWrapper", function (t) {
      return function (e) {
        t(e.target.value);
      };
    }), _defineProperty(_assertThisInitialized(t), "onKeyDown", function (e) {
      27 === e.keyCode && t.props.onHide();
    }), t;
  }

  return _createClass(s, [{
    key: "componentDidMount",
    value: function value() {
      document.addEventListener("keydown", this.onKeyDown, !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      document.removeEventListener("keydown", this.onKeyDown, !1);
    }
  }, {
    key: "render",
    value: function value() {
      var t = this,
          e = this.props,
          o = e.classes,
          a = e.options,
          r = e.onHide,
          n = e.searchText,
          s = debounce(function (e) {
        t.props.onSearch(e);
      }, e.debounceWait);
      return React__default.createElement(Grow, {
        appear: !0,
        in: !0,
        timeout: 300
      }, React__default.createElement("div", {
        className: o.main
      }, React__default.createElement(SearchIcon, {
        className: o.searchIcon
      }), React__default.createElement(TextField, _extends({
        className: o.searchText,
        autoFocus: !0,
        InputProps: {
          "data-test-id": a.textLabels.toolbar.search,
          "aria-label": a.textLabels.toolbar.search
        },
        defaultValue: n,
        onChange: this.handleTextChangeWrapper(s),
        fullWidth: !0,
        inputRef: function inputRef(e) {
          return t.searchField = e;
        },
        placeholder: a.searchPlaceholder
      }, a.searchProps ? a.searchProps : {})), React__default.createElement(IconButton, {
        className: o.clearIcon,
        onClick: r
      }, React__default.createElement(ClearIcon, null))));
    }
  }]), s;
}(React__default.Component),
    DebounceTableSearch = styles.withStyles(defaultStyles, {
  name: "MUIDataTableSearch"
})(_DebounceTableSearch);

function debounceSearchRender() {
  var r = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 200;
  return function (e, t, o, a) {
    return React__default.createElement(DebounceTableSearch, {
      searchText: e,
      onSearch: t,
      onHide: o,
      options: a,
      debounceWait: r
    });
  };
}

exports.DebounceTableSearch = DebounceTableSearch, exports.ExpandButton = ExpandButton, exports.Popover = Popover, exports.TableBody = DefaultTableBody, exports.TableBodyCell = TableBodyCell, exports.TableBodyRow = TableBodyRow$1, exports.TableFilter = DefaultTableFilter, exports.TableFilterList = TableFilterList, exports.TableFooter = TableFooter, exports.TableHead = TableHead, exports.TableHeadCell = TableHeadCell, exports.TableHeadRow = TableHeadRow, exports.TablePagination = TablePagination, exports.TableResize = DefaultTableResize, exports.TableSearch = TableSearch, exports.TableSelectCell = TableSelectCell, exports.TableToolbar = DefaultTableToolbar, exports.TableToolbarSelect = DefaultTableToolbarSelect, exports.TableViewCol = TableViewCol, exports.debounceSearchRender = debounceSearchRender, exports.default = MUIDataTable$1;